var Zt = Object.defineProperty;
var De = (e) => {
  throw TypeError(e);
};
var Ft = (e, t, n) => t in e ? Zt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var L = (e, t, n) => Ft(e, typeof t != "symbol" ? t + "" : t, n), At = (e, t, n) => t.has(e) || De("Cannot " + n);
var Ze = (e, t, n) => t.has(e) ? De("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n);
var ge = (e, t, n) => (At(e, t, "access private method"), n);
import P, { createContext as Me, useContext as xe, useEffect as y, useState as w, useCallback as g, useMemo as x, useRef as N, useSyncExternalStore as ye, useLayoutEffect as Gt, forwardRef as Ut, useImperativeHandle as zt } from "react";
import { jsxs as v, Fragment as T, jsx as i } from "react/jsx-runtime";
import { useFloating as Be, useTransitionStyles as Ve, useDismiss as jt, useInteractions as Wt, offset as A, shift as le, flip as W, size as Se, FloatingPortal as $t } from "@floating-ui/react";
import { BlockNoteEditor as qt, BlockNoteSchema as Kt, defaultStyleSpecs as Xt, createBlockSpecFromStronglyTypedTiptapNode as Yt, createStronglyTypedTiptapNode as Te, defaultBlockSpecs as Jt, mergeCSSClasses as R, filenameFromURL as Fe, formatKeyboardShortcut as ce, VALID_LINK_PROTOCOLS as Qt, DEFAULT_LINK_PROTOCOL as en, isTableCellSelection as tn, checkBlockIsFileBlock as J, checkBlockIsFileBlockWithPlaceholder as Q, checkBlockIsFileBlockWithPreview as nn, checkBlockHasDefaultProp as ke, mapTableCell as K, checkBlockTypeHasDefaultProp as q, getDefaultEmojiPickerItems as on, getDefaultSlashMenuItems as rn, filterSuggestionItems as ln, EMPTY_CELL_WIDTH as cn, EMPTY_CELL_HEIGHT as an, isTableCell as X, getColspan as nt, getRowspan as ot, getBlockFromPos as sn, applyNonSelectableBlockFix as dn, wrapInBlockStructure as un, getParseRules as mn, propsToAttributes as rt, createInternalBlockSpec as hn, inheritedProps as fn, camelToDataKebab as it, audioParse as gn, audioBlockConfig as bn, fileParse as Cn, fileBlockConfig as pn, imageParse as kn, imageBlockConfig as wn, getPageBreakSlashMenuItems as vn, videoParse as Hn, videoBlockConfig as Mn, UnreachableCaseError as xn, nodeToCustomInlineContent as Ae, inlineContentToNodes as yn, addInlineContentAttributes as Bn, getInlineContentParseRules as Vn, addInlineContentKeyboardShortcuts as Sn, createInternalInlineContentSpec as Tn, addStyleAttributes as Ln, getStyleParseRules as En, stylePropsToAttributes as Rn, createInternalStyleSpec as _n } from "@blocknote/core";
import { createPortal as ae, flushSync as lt } from "react-dom";
import { ReactNodeViewRenderer as ct, useReactNodeView as at, NodeViewWrapper as st, Mark as In } from "@tiptap/react";
import { createRoot as Nn } from "react-dom/client";
const dt = Me(void 0);
function D(e) {
  return xe(dt);
}
function b(e) {
  const t = D();
  if (!(t != null && t.editor))
    throw new Error(
      "useBlockNoteEditor was called outside of a BlockNoteContext provider or BlockNoteView component"
    );
  return t.editor;
}
function se(e, t, n) {
  const o = D();
  t || (t = o == null ? void 0 : o.editor), y(() => {
    if (!t)
      throw new Error(
        "'editor' is required, either from BlockNoteContext or as a function argument"
      );
    return t.onSelectionChange(e, n);
  }, [e, t, n]);
}
function Pn(e, t) {
  const n = b();
  t = t || n;
  const [o, r] = w(() => {
    if (e)
      return t.getSelectionBoundingBox();
  }), l = g(() => {
    if (!e)
      return;
    const c = t.getSelectionBoundingBox();
    r(c);
  }, [t, e]);
  return se(l, t, !0), y(() => {
    r(e ? t.getSelectionBoundingBox() : void 0);
  }, [e, t]), o;
}
function G(e, t, n, o) {
  const { refs: r, update: l, context: c, floatingStyles: d } = Be({
    open: e,
    ...o
  }), { isMounted: s, styles: a } = Ve(c), u = jt(c), { getReferenceProps: m, getFloatingProps: h } = Wt([u]);
  return y(() => {
    l();
  }, [t, l]), y(() => {
    t !== null && r.setReference({
      getBoundingClientRect: () => t
    });
  }, [t, r]), x(() => ({
    isMounted: s,
    ref: r.setFloating,
    setReference: r.setReference,
    style: {
      display: "flex",
      ...a,
      ...d,
      zIndex: n
    },
    getFloatingProps: h,
    getReferenceProps: m
  }), [
    d,
    s,
    r.setFloating,
    r.setReference,
    a,
    n,
    h,
    m
  ]);
}
function O(e) {
  const [t, n] = w();
  return y(() => e((o) => {
    n({ ...o });
  }), [e]), t;
}
const On = Me(
  void 0
);
function C() {
  return xe(On);
}
const de = (e = {}, t = []) => x(() => {
  const n = qt.create(e);
  return window && (window.ProseMirror = n._tiptapEditor), n;
}, t), Oi = de;
function M() {
  return D().editor.dictionary;
}
function ue(e, t) {
  const n = D();
  t || (t = n == null ? void 0 : n.editor), y(() => {
    if (!t)
      throw new Error(
        "'editor' is required, either from BlockNoteContext or as a function argument"
      );
    return t.onChange(e);
  }, [e, t]);
}
const Le = (e) => {
  const [t, n] = w(!1), [o, r] = w(e.editor.isEmpty), l = C();
  ue(() => {
    r(e.editor.isEmpty);
  }, e.editor);
  const c = g(() => {
    n(!0);
  }, []), d = g(() => {
    n(!1);
  }, []);
  return y(() => {
    e.editable && e.autoFocus && e.editor.focus();
  }, [e.autoFocus, e.editable, e.editor]), /* @__PURE__ */ v(T, { children: [
    /* @__PURE__ */ i(
      l.Comments.Editor,
      {
        autoFocus: e.autoFocus,
        className: "bn-comment-editor",
        editor: e.editor,
        onFocus: c,
        onBlur: d,
        editable: e.editable
      }
    ),
    e.actions && /* @__PURE__ */ i("div", { className: "bn-comment-actions-wrapper", children: /* @__PURE__ */ i(e.actions, { isFocused: t, isEmpty: o }) })
  ] });
}, Dn = Yt(
  Te(
    Jt.paragraph.implementation.node.config
  ),
  // disable default props on paragraph (such as textalignment and colors)
  {}
), { textColor: Di, backgroundColor: Zi, ...Zn } = Xt, Ee = Kt.create({
  blockSpecs: {
    paragraph: Dn
  },
  styleSpecs: Zn
});
function Fn() {
  const e = b();
  if (!e.comments)
    throw new Error("Comments plugin not found");
  const t = e.comments, n = C(), o = M(), r = de({
    trailingBlock: !1,
    dictionary: {
      ...o,
      placeholders: {
        emptyDocument: o.placeholders.new_comment
      }
    },
    schema: Ee,
    sideMenuDetection: "editor"
  });
  return /* @__PURE__ */ i(n.Comments.Card, { className: "bn-thread", children: /* @__PURE__ */ i(
    Le,
    {
      autoFocus: !0,
      editable: !0,
      editor: r,
      actions: ({ isEmpty: l }) => /* @__PURE__ */ i(
        n.Generic.Toolbar.Root,
        {
          className: R(
            "bn-action-toolbar",
            "bn-comment-actions"
          ),
          variant: "action-toolbar",
          children: /* @__PURE__ */ i(
            n.Generic.Toolbar.Button,
            {
              className: "bn-button",
              mainTooltip: "Save",
              variant: "compact",
              isDisabled: l,
              onClick: async () => {
                await t.createThread({
                  initialComment: {
                    body: r.document
                  }
                }), t.stopPendingComment();
              },
              children: "Save"
            }
          )
        }
      )
    }
  ) });
}
const An = (e) => {
  const t = b();
  if (!t.comments)
    throw new Error(
      "FloatingComposerController can only be used when BlockNote editor has enabled comments"
    );
  const n = t.comments;
  y(() => {
    const u = n.onUpdate(
      (m) => t.setForceSelectionVisible(m.pendingComment)
    );
    return () => u();
  }, [n, t]);
  const o = O(n.onUpdate.bind(n)), r = Pn(o == null ? void 0 : o.pendingComment), { isMounted: l, ref: c, style: d, getFloatingProps: s } = G(
    (o == null ? void 0 : o.pendingComment) || !1,
    r || null,
    5e3,
    {
      placement: "bottom",
      middleware: [A(10), le(), W()],
      onOpenChange: (u) => {
        u || (n.stopPendingComment(), t.focus());
      },
      ...e.floatingOptions
    }
  );
  if (!l || !o)
    return null;
  const a = e.floatingComposer || Fn;
  return /* @__PURE__ */ i("div", { ref: c, style: d, ...s(), children: /* @__PURE__ */ i(a, {}) });
};
var ut = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, Ge = P.createContext && /* @__PURE__ */ P.createContext(ut), Gn = ["attr", "size", "title"];
function Un(e, t) {
  if (e == null) return {};
  var n = zn(e, t), o, r;
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    for (r = 0; r < l.length; r++)
      o = l[r], !(t.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
  }
  return n;
}
function zn(e, t) {
  if (e == null) return {};
  var n = {};
  for (var o in e)
    if (Object.prototype.hasOwnProperty.call(e, o)) {
      if (t.indexOf(o) >= 0) continue;
      n[o] = e[o];
    }
  return n;
}
function oe() {
  return oe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, oe.apply(this, arguments);
}
function Ue(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function re(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ue(Object(n), !0).forEach(function(o) {
      jn(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ue(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function jn(e, t, n) {
  return t = Wn(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Wn(e) {
  var t = $n(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function $n(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function mt(e) {
  return e && e.map((t, n) => /* @__PURE__ */ P.createElement(t.tag, re({
    key: n
  }, t.attr), mt(t.child)));
}
function k(e) {
  return (t) => /* @__PURE__ */ P.createElement(qn, oe({
    attr: re({}, e.attr)
  }, t), mt(e.child));
}
function qn(e) {
  var t = (n) => {
    var {
      attr: o,
      size: r,
      title: l
    } = e, c = Un(e, Gn), d = r || n.size || "1em", s;
    return n.className && (s = n.className), e.className && (s = (s ? s + " " : "") + e.className), /* @__PURE__ */ P.createElement("svg", oe({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, n.attr, o, c, {
      className: s,
      style: re(re({
        color: e.color || n.color
      }, n.style), e.style),
      height: d,
      width: d,
      xmlns: "http://www.w3.org/2000/svg"
    }), l && /* @__PURE__ */ P.createElement("title", null, l), e.children);
  };
  return Ge !== void 0 ? /* @__PURE__ */ P.createElement(Ge.Consumer, null, (n) => t(n)) : t(ut);
}
function Kn(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 7V11L2 6L8 1V5H13C17.4183 5 21 8.58172 21 13C21 17.4183 17.4183 21 13 21H4V19H13C16.3137 19 19 16.3137 19 13C19 9.68629 16.3137 7 13 7H8Z" }, child: [] }] })(e);
}
function ht(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M7.29117 20.8242L2 22L3.17581 16.7088C2.42544 15.3056 2 13.7025 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.2975 22 8.6944 21.5746 7.29117 20.8242ZM7.58075 18.711L8.23428 19.0605C9.38248 19.6745 10.6655 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 13.3345 4.32549 14.6175 4.93949 15.7657L5.28896 16.4192L4.63416 19.3658L7.58075 18.711Z" }, child: [] }] })(e);
}
function Xn(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M7.24264 17.9967H3V13.754L14.435 2.319C14.8256 1.92848 15.4587 1.92848 15.8492 2.319L18.6777 5.14743C19.0682 5.53795 19.0682 6.17112 18.6777 6.56164L7.24264 17.9967ZM3 19.9967H21V21.9967H3V19.9967Z" }, child: [] }] })(e);
}
function Yn(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M23 12L15.9289 19.0711L14.5147 17.6569L20.1716 12L14.5147 6.34317L15.9289 4.92896L23 12ZM3.82843 12L9.48528 17.6569L8.07107 19.0711L1 12L8.07107 4.92896L9.48528 6.34317L3.82843 12Z" }, child: [] }] })(e);
}
function Re(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 8L9.00319 2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8ZM10 4V9H5V20H19V4H10Z" }, child: [] }] })(e);
}
function Jn(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM5 19H19V21H5V19ZM3 14H21V16H3V14ZM5 9H19V11H5V9Z" }, child: [] }] })(e);
}
function Qn(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM3 14H21V16H3V14ZM3 9H21V11H3V9Z" }, child: [] }] })(e);
}
function eo(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM3 19H17V21H3V19ZM3 14H21V16H3V14ZM3 9H17V11H3V9Z" }, child: [] }] })(e);
}
function to(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM7 19H21V21H7V19ZM3 14H21V16H3V14ZM7 9H21V11H7V9Z" }, child: [] }] })(e);
}
function no(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 11H12.5C13.8807 11 15 9.88071 15 8.5C15 7.11929 13.8807 6 12.5 6H8V11ZM18 15.5C18 17.9853 15.9853 20 13.5 20H6V4H12.5C14.9853 4 17 6.01472 17 8.5C17 9.70431 16.5269 10.7981 15.7564 11.6058C17.0979 12.3847 18 13.837 18 15.5ZM8 13V18H13.5C14.8807 18 16 16.8807 16 15.5C16 14.1193 14.8807 13 13.5 13H8Z" }, child: [] }] })(e);
}
function oo(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3.41436 5.99995L5.70726 3.70706L4.29304 2.29285L0.585938 5.99995L4.29304 9.70706L5.70726 8.29285L3.41436 5.99995ZM9.58594 5.99995L7.29304 3.70706L8.70726 2.29285L12.4144 5.99995L8.70726 9.70706L7.29304 8.29285L9.58594 5.99995ZM14.0002 2.99995H21.0002C21.5524 2.99995 22.0002 3.44767 22.0002 3.99995V20C22.0002 20.5522 21.5524 21 21.0002 21H3.00015C2.44787 21 2.00015 20.5522 2.00015 20V12H4.00015V19H20.0002V4.99995H14.0002V2.99995Z" }, child: [] }] })(e);
}
function ze(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M5.55397 22H3.3999L10.9999 3H12.9999L20.5999 22H18.4458L16.0458 16H7.95397L5.55397 22ZM8.75397 14H15.2458L11.9999 5.88517L8.75397 14Z" }, child: [] }] })(e);
}
function ft(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M13 20H11V13H4V20H2V4H4V11H11V4H13V20ZM21.0005 8V20H19.0005L19 10.204L17 10.74V8.67L19.5005 8H21.0005Z" }, child: [] }] })(e);
}
function gt(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M4 4V11H11V4H13V20H11V13H4V20H2V4H4ZM18.5 8C20.5711 8 22.25 9.67893 22.25 11.75C22.25 12.6074 21.9623 13.3976 21.4781 14.0292L21.3302 14.2102L18.0343 18H22V20H15L14.9993 18.444L19.8207 12.8981C20.0881 12.5908 20.25 12.1893 20.25 11.75C20.25 10.7835 19.4665 10 18.5 10C17.5818 10 16.8288 10.7071 16.7558 11.6065L16.75 11.75H14.75C14.75 9.67893 16.4289 8 18.5 8Z" }, child: [] }] })(e);
}
function bt(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M22 8L21.9984 10L19.4934 12.883C21.0823 13.3184 22.25 14.7728 22.25 16.5C22.25 18.5711 20.5711 20.25 18.5 20.25C16.674 20.25 15.1528 18.9449 14.8184 17.2166L16.7821 16.8352C16.9384 17.6413 17.6481 18.25 18.5 18.25C19.4665 18.25 20.25 17.4665 20.25 16.5C20.25 15.5335 19.4665 14.75 18.5 14.75C18.214 14.75 17.944 14.8186 17.7056 14.9403L16.3992 13.3932L19.3484 10H15V8H22ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4Z" }, child: [] }] })(e);
}
function ro(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM11 14H21V16H11V14ZM11 9H21V11H11V9ZM3 12.5L7 9V16L3 12.5Z" }, child: [] }] })(e);
}
function io(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM11 14H21V16H11V14ZM11 9H21V11H11V9ZM7 12.5L3 16V9L7 12.5Z" }, child: [] }] })(e);
}
function je(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 5H11V19H8V21H16V19H13V5H16V3H8V5ZM2 7C1.44772 7 1 7.44772 1 8V16C1 16.5523 1.44772 17 2 17H8V15H3V9H8V7H2ZM16 9H21V15H16V17H22C22.5523 17 23 16.5523 23 16V8C23 7.44772 22.5523 7 22 7H16V9Z" }, child: [] }] })(e);
}
function lo(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M15 20H7V18H9.92661L12.0425 6H9V4H17V6H14.0734L11.9575 18H15V20Z" }, child: [] }] })(e);
}
function co(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M17 17H22V19H19V22H17V17ZM7 7H2V5H5V2H7V7ZM18.364 15.5355L16.9497 14.1213L18.364 12.7071C20.3166 10.7545 20.3166 7.58866 18.364 5.63604C16.4113 3.68342 13.2455 3.68342 11.2929 5.63604L9.87868 7.05025L8.46447 5.63604L9.87868 4.22183C12.6123 1.48816 17.0445 1.48816 19.7782 4.22183C22.5118 6.9555 22.5118 11.3877 19.7782 14.1213L18.364 15.5355ZM15.5355 18.364L14.1213 19.7782C11.3877 22.5118 6.9555 22.5118 4.22183 19.7782C1.48816 17.0445 1.48816 12.6123 4.22183 9.87868L5.63604 8.46447L7.05025 9.87868L5.63604 11.2929C3.68342 13.2455 3.68342 16.4113 5.63604 18.364C7.58866 20.3166 10.7545 20.3166 12.7071 18.364L14.1213 16.9497L15.5355 18.364ZM14.8284 7.75736L16.2426 9.17157L9.17157 16.2426L7.75736 14.8284L14.8284 7.75736Z" }, child: [] }] })(e);
}
function Ct(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M18.3638 15.5355L16.9496 14.1213L18.3638 12.7071C20.3164 10.7545 20.3164 7.58866 18.3638 5.63604C16.4112 3.68341 13.2453 3.68341 11.2927 5.63604L9.87849 7.05025L8.46428 5.63604L9.87849 4.22182C12.6122 1.48815 17.0443 1.48815 19.778 4.22182C22.5117 6.95549 22.5117 11.3876 19.778 14.1213L18.3638 15.5355ZM15.5353 18.364L14.1211 19.7782C11.3875 22.5118 6.95531 22.5118 4.22164 19.7782C1.48797 17.0445 1.48797 12.6123 4.22164 9.87868L5.63585 8.46446L7.05007 9.87868L5.63585 11.2929C3.68323 13.2455 3.68323 16.4113 5.63585 18.364C7.58847 20.3166 10.7543 20.3166 12.7069 18.364L14.1211 16.9497L15.5353 18.364ZM14.8282 7.75736L16.2425 9.17157L9.17139 16.2426L7.75717 14.8284L14.8282 7.75736Z" }, child: [] }] })(e);
}
function pt(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8.00008 6V9H5.00008V6H8.00008ZM3.00008 4V11H10.0001V4H3.00008ZM13.0001 4H21.0001V6H13.0001V4ZM13.0001 11H21.0001V13H13.0001V11ZM13.0001 18H21.0001V20H13.0001V18ZM10.7072 16.2071L9.29297 14.7929L6.00008 18.0858L4.20718 16.2929L2.79297 17.7071L6.00008 20.9142L10.7072 16.2071Z" }, child: [] }] })(e);
}
function kt(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 4H21V6H8V4ZM5 3V6H6V7H3V6H4V4H3V3H5ZM3 14V11.5H5V11H3V10H6V12.5H4V13H6V14H3ZM5 19.5H3V18.5H5V18H3V17H6V21H3V20H5V19.5ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z" }, child: [] }] })(e);
}
function wt(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 4H21V6H8V4ZM4.5 6.5C3.67157 6.5 3 5.82843 3 5C3 4.17157 3.67157 3.5 4.5 3.5C5.32843 3.5 6 4.17157 6 5C6 5.82843 5.32843 6.5 4.5 6.5ZM4.5 13.5C3.67157 13.5 3 12.8284 3 12C3 11.1716 3.67157 10.5 4.5 10.5C5.32843 10.5 6 11.1716 6 12C6 12.8284 5.32843 13.5 4.5 13.5ZM4.5 20.4C3.67157 20.4 3 19.7284 3 18.9C3 18.0716 3.67157 17.4 4.5 17.4C5.32843 17.4 6 18.0716 6 18.9C6 19.7284 5.32843 20.4 4.5 20.4ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z" }, child: [] }] })(e);
}
function ao(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM11 5H5V10.999H7V9L10 12L7 15V13H5V19H11V17H13V19H19V13H17V15L14 12L17 9V10.999H19V5H13V7H11V5ZM13 13V15H11V13H13ZM13 9V11H11V9H13Z" }, child: [] }] })(e);
}
function so(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20ZM19 11V5H13.001V7H15L12 10L9 7H11V5H5V11H7V13H5V19H11V17H9L12 14L15 17H13.001V19H19V13H17V11H19ZM11 13H9V11H11V13ZM15 13H13V11H15V13Z" }, child: [] }] })(e);
}
function vt(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M21 4H3V6H21V4ZM21 11H8V13H21V11ZM21 18H8V20H21V18ZM5 11H3V20H5V11Z" }, child: [] }] })(e);
}
function uo(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M17.1538 14C17.3846 14.5161 17.5 15.0893 17.5 15.7196C17.5 17.0625 16.9762 18.1116 15.9286 18.867C14.8809 19.6223 13.4335 20 11.5862 20C9.94674 20 8.32335 19.6185 6.71592 18.8555V16.6009C8.23538 17.4783 9.7908 17.917 11.3822 17.917C13.9333 17.917 15.2128 17.1846 15.2208 15.7196C15.2208 15.0939 15.0049 14.5598 14.5731 14.1173C14.5339 14.0772 14.4939 14.0381 14.4531 14H3V12H21V14H17.1538ZM13.076 11H7.62908C7.4566 10.8433 7.29616 10.6692 7.14776 10.4778C6.71592 9.92084 6.5 9.24559 6.5 8.45207C6.5 7.21602 6.96583 6.165 7.89749 5.299C8.82916 4.43299 10.2706 4 12.2219 4C13.6934 4 15.1009 4.32808 16.4444 4.98426V7.13591C15.2448 6.44921 13.9293 6.10587 12.4978 6.10587C10.0187 6.10587 8.77917 6.88793 8.77917 8.45207C8.77917 8.87172 8.99709 9.23796 9.43293 9.55079C9.86878 9.86362 10.4066 10.1135 11.0463 10.3004C11.6665 10.4816 12.3431 10.7148 13.076 11H13.076Z" }, child: [] }] })(e);
}
function mo(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M13 10V14H19V10H13ZM11 10H5V14H11V10ZM13 19H19V16H13V19ZM11 19V16H5V19H11ZM13 5V8H19V5H13ZM11 5H5V8H11V5ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z" }, child: [] }] })(e);
}
function _e(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M13 6V21H11V6H5V4H19V6H13Z" }, child: [] }] })(e);
}
function ho(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 3V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V3H18V12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12V3H8ZM4 20H20V22H4V20Z" }, child: [] }] })(e);
}
function fo(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM8 5V19H16V5H8ZM4 5V7H6V5H4ZM18 5V7H20V5H18ZM4 9V11H6V9H4ZM18 9V11H20V9H18ZM4 13V15H6V13H4ZM18 13V15H20V13H18ZM4 17V19H6V17H4ZM18 17V19H20V17H18Z" }, child: [] }] })(e);
}
function Ht(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M5 11.1005L7 9.1005L12.5 14.6005L16 11.1005L19 14.1005V5H5V11.1005ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10Z" }, child: [] }] })(e);
}
function go(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M21 15V18H24V20H21V23H19V20H16V18H19V15H21ZM21.0082 3C21.556 3 22 3.44495 22 3.9934L22.0007 13.3417C21.3749 13.1204 20.7015 13 20 13V5H4L4.001 19L13.2929 9.70715C13.6528 9.34604 14.22 9.31823 14.6123 9.62322L14.7065 9.70772L18.2521 13.2586C15.791 14.0069 14 16.2943 14 19C14 19.7015 14.1204 20.3749 14.3417 21.0007L2.9918 21C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082ZM8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7Z" }, child: [] }] })(e);
}
function bo(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M20 3C20.5523 3 21 3.44772 21 4V5.757L19 7.757V5H5V13.1L9 9.1005L13.328 13.429L12.0012 14.7562L11.995 18.995L16.2414 19.0012L17.571 17.671L18.8995 19H19V16.242L21 14.242V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM21.7782 7.80761L23.1924 9.22183L15.4142 17L13.9979 16.9979L14 15.5858L21.7782 7.80761ZM15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7Z" }, child: [] }] })(e);
}
function Co(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44495 21 3.9934V20.0066C21 20.5552 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5551 3 20.0066V3.9934ZM10.6219 8.41459C10.5562 8.37078 10.479 8.34741 10.4 8.34741C10.1791 8.34741 10 8.52649 10 8.74741V15.2526C10 15.3316 10.0234 15.4088 10.0672 15.4745C10.1897 15.6583 10.4381 15.708 10.6219 15.5854L15.5008 12.3328C15.5447 12.3035 15.5824 12.2658 15.6117 12.2219C15.7343 12.0381 15.6846 11.7897 15.5008 11.6672L10.6219 8.41459Z" }, child: [] }] })(e);
}
function Mt(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M2 16.0001H5.88889L11.1834 20.3319C11.2727 20.405 11.3846 20.4449 11.5 20.4449C11.7761 20.4449 12 20.2211 12 19.9449V4.05519C12 3.93977 11.9601 3.8279 11.887 3.73857C11.7121 3.52485 11.3971 3.49335 11.1834 3.66821L5.88889 8.00007H2C1.44772 8.00007 1 8.44778 1 9.00007V15.0001C1 15.5524 1.44772 16.0001 2 16.0001ZM23 12C23 15.292 21.5539 18.2463 19.2622 20.2622L17.8445 18.8444C19.7758 17.1937 21 14.7398 21 12C21 9.26016 19.7758 6.80629 17.8445 5.15557L19.2622 3.73779C21.5539 5.75368 23 8.70795 23 12ZM18 12C18 10.0883 17.106 8.38548 15.7133 7.28673L14.2842 8.71584C15.3213 9.43855 16 10.64 16 12C16 13.36 15.3213 14.5614 14.2842 15.2841L15.7133 16.7132C17.106 15.6145 18 13.9116 18 12Z" }, child: [] }] })(e);
}
function po(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" }, child: [] }] })(e);
}
function ko(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z" }, child: [] }] })(e);
}
function wo(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 4V6H15V4H9Z" }, child: [] }] })(e);
}
function vo(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM9 11V17H11V11H9ZM13 11V17H15V11H13ZM9 4V6H15V4H9Z" }, child: [] }] })(e);
}
function Ho(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19ZM14 9H19L12 16L5 9H10V3H14V9Z" }, child: [] }] })(e);
}
function Mo(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V12L17.206 8.207L11.2071 14.2071L9.79289 12.7929L15.792 6.793L12 3H21Z" }, child: [] }] })(e);
}
function xo(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M5 10C3.9 10 3 10.9 3 12C3 13.1 3.9 14 5 14C6.1 14 7 13.1 7 12C7 10.9 6.1 10 5 10ZM19 10C17.9 10 17 10.9 17 12C17 13.1 17.9 14 19 14C20.1 14 21 13.1 21 12C21 10.9 20.1 10 19 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z" }, child: [] }] })(e);
}
function yo(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13H8ZM8 11C8.82843 11 9.5 10.3284 9.5 9.5C9.5 8.67157 8.82843 8 8 8C7.17157 8 6.5 8.67157 6.5 9.5C6.5 10.3284 7.17157 11 8 11ZM16 11C16.8284 11 17.5 10.3284 17.5 9.5C17.5 8.67157 16.8284 8 16 8C15.1716 8 14.5 8.67157 14.5 9.5C14.5 10.3284 15.1716 11 16 11Z" }, child: [] }] })(e);
}
function We(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM8 13H16C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13ZM8 11C7.17157 11 6.5 10.3284 6.5 9.5C6.5 8.67157 7.17157 8 8 8C8.82843 8 9.5 8.67157 9.5 9.5C9.5 10.3284 8.82843 11 8 11ZM16 11C15.1716 11 14.5 10.3284 14.5 9.5C14.5 8.67157 15.1716 8 16 8C16.8284 8 17.5 8.67157 17.5 9.5C17.5 10.3284 16.8284 11 16 11Z" }, child: [] }] })(e);
}
let te;
async function Bo() {
  return te || (te = (async () => {
    const [e, t] = await Promise.all([
      import("emoji-mart"),
      // use a dynamic import to encourage bundle-splitting
      // and a smaller initial client bundle size
      import("@emoji-mart/data")
    ]), n = "default" in e ? e.default : e, o = "default" in t ? t.default : t;
    return await n.init({ data: o }), { emojiMart: n, emojiData: o };
  })(), te);
}
function Vo(e) {
  const t = N(null), n = N(null);
  return n.current && n.current.update(e), y(() => ((async () => {
    const { emojiMart: o } = await Bo();
    n.current = new o.Picker({ ...e, ref: t });
  })(), () => {
    n.current = null;
  }), []), P.createElement("div", { ref: t });
}
const $e = (e) => {
  const [t, n] = w(!1), o = C(), r = D();
  return /* @__PURE__ */ v(o.Generic.Popover.Root, { opened: t, children: [
    /* @__PURE__ */ i(o.Generic.Popover.Trigger, { children: /* @__PURE__ */ i(
      "div",
      {
        onClick: (l) => {
          l.preventDefault(), l.stopPropagation(), n(!t);
        },
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        children: e.children
      }
    ) }),
    /* @__PURE__ */ i(o.Generic.Popover.Content, { variant: "panel-popover", children: /* @__PURE__ */ i(
      Vo,
      {
        perLine: 7,
        onClickOutside: () => n(!1),
        onEmojiSelect: (l) => {
          e.onEmojiSelect(l), n(!1);
        },
        theme: r == null ? void 0 : r.colorSchemePreference
      }
    ) })
  ] });
};
function So(e, t) {
  return Ie(e, [t]).get(t);
}
function Ie(e, t) {
  const n = e.comments;
  if (!n)
    throw new Error("Comments plugin not found");
  const o = n.userStore, r = g(() => {
    const d = /* @__PURE__ */ new Map();
    for (const s of t) {
      const a = o.getUser(s);
      a && d.set(s, a);
    }
    return d;
  }, [o, t]), l = x(() => ({
    current: r()
  }), [r]), c = g(
    (d) => {
      const s = o.subscribe((a) => {
        l.current = r(), d();
      });
      return o.loadUsers(t), s;
    },
    [o, r, t, l]
  );
  return ye(c, () => l.current);
}
const To = (e) => {
  const t = C(), n = M(), o = b();
  if (!o.comments)
    throw new Error(
      "ReactionBadge must be used inside a BlockNote editor with comments enabled"
    );
  const r = e.comment.reactions.find(
    (s) => s.emoji === e.emoji
  );
  if (!r)
    throw new Error(
      "Trying to render reaction badge for non-existing reaction"
    );
  const [l, c] = w([]), d = Ie(o, l);
  return /* @__PURE__ */ i(
    t.Generic.Badge.Root,
    {
      className: R("bn-badge", "bn-comment-reaction"),
      text: r.userIds.length.toString(),
      icon: r.emoji,
      isSelected: o.comments.threadStore.auth.canDeleteReaction(
        e.comment,
        r.emoji
      ),
      onClick: () => e.onReactionSelect(r.emoji),
      onMouseEnter: () => c(r.userIds),
      mainTooltip: n.comments.reactions.reacted_by,
      secondaryTooltip: `${Array.from(d.values()).map((s) => s.username).join(`
`)}`
    },
    r.emoji
  );
}, Lo = ({
  comment: e,
  thread: t,
  showResolveButton: n
}) => {
  const o = M(), r = de(
    {
      initialContent: e.body,
      trailingBlock: !1,
      dictionary: {
        ...o,
        placeholders: {
          emptyDocument: o.placeholders.edit_comment
        }
      },
      schema: Ee,
      sideMenuDetection: "editor"
    },
    [e.body]
  ), l = C(), [c, d] = w(!1), s = b();
  if (!s.comments)
    throw new Error("Comments plugin not found");
  const a = s.comments.threadStore, u = g(() => {
    d(!0);
  }, []), m = g(() => {
    r.replaceBlocks(r.document, e.body), d(!1);
  }, [r, e.body]), h = g(
    async (E) => {
      await a.updateComment({
        commentId: e.id,
        comment: {
          body: r.document
        },
        threadId: t.id
      }), d(!1);
    },
    [e, t.id, r, a]
  ), f = g(async () => {
    await a.deleteComment({
      commentId: e.id,
      threadId: t.id
    });
  }, [e, t.id, a]), H = g(
    async (E) => {
      a.auth.canAddReaction(e, E) ? await a.addReaction({
        threadId: t.id,
        commentId: e.id,
        emoji: E
      }) : a.auth.canDeleteReaction(e, E) && await a.deleteReaction({
        threadId: t.id,
        commentId: e.id,
        emoji: E
      });
    },
    [a, e, t.id]
  ), p = g(async () => {
    await a.resolveThread({
      threadId: t.id
    });
  }, [t.id, a]), V = g(async () => {
    await a.unresolveThread({
      threadId: t.id
    });
  }, [t.id, a]), B = So(s, e.userId);
  if (!e.body)
    return null;
  let S;
  const I = a.auth.canAddReaction(e), z = a.auth.canDeleteComment(e), j = a.auth.canUpdateComment(e), Z = n && (t.resolved ? a.auth.canUnresolveThread(t) : a.auth.canResolveThread(t));
  c || (S = /* @__PURE__ */ v(
    l.Generic.Toolbar.Root,
    {
      className: R("bn-action-toolbar", "bn-comment-actions"),
      variant: "action-toolbar",
      children: [
        I && /* @__PURE__ */ i(
          $e,
          {
            onEmojiSelect: (E) => H(E.native),
            children: /* @__PURE__ */ i(
              l.Generic.Toolbar.Button,
              {
                mainTooltip: o.comments.actions.add_reaction,
                variant: "compact",
                children: /* @__PURE__ */ i(We, { size: 16 })
              },
              "add-reaction"
            )
          }
        ),
        Z && (t.resolved ? /* @__PURE__ */ i(
          l.Generic.Toolbar.Button,
          {
            mainTooltip: "Re-open",
            variant: "compact",
            onClick: V,
            children: /* @__PURE__ */ i(Kn, { size: 16 })
          },
          "reopen"
        ) : /* @__PURE__ */ i(
          l.Generic.Toolbar.Button,
          {
            mainTooltip: o.comments.actions.resolve,
            variant: "compact",
            onClick: p,
            children: /* @__PURE__ */ i(ko, { size: 16 })
          },
          "resolve"
        )),
        (z || j) && /* @__PURE__ */ v(l.Generic.Menu.Root, { position: "bottom-start", children: [
          /* @__PURE__ */ i(l.Generic.Menu.Trigger, { children: /* @__PURE__ */ i(
            l.Generic.Toolbar.Button,
            {
              mainTooltip: o.comments.actions.more_actions,
              variant: "compact",
              children: /* @__PURE__ */ i(xo, { size: 16 })
            },
            "more-actions"
          ) }),
          /* @__PURE__ */ v(l.Generic.Menu.Dropdown, { className: "bn-menu-dropdown", children: [
            j && /* @__PURE__ */ i(
              l.Generic.Menu.Item,
              {
                icon: /* @__PURE__ */ i(Xn, {}),
                onClick: u,
                children: o.comments.actions.edit_comment
              },
              "edit-comment"
            ),
            z && /* @__PURE__ */ i(
              l.Generic.Menu.Item,
              {
                icon: /* @__PURE__ */ i(vo, {}),
                onClick: f,
                children: o.comments.actions.delete_comment
              },
              "delete-comment"
            )
          ] })
        ] })
      ]
    }
  ));
  const $ = e.createdAt.toLocaleDateString(void 0, {
    month: "short",
    day: "numeric"
  });
  if (!e.body)
    throw new Error("soft deletes are not yet supported");
  return /* @__PURE__ */ i(
    l.Comments.Comment,
    {
      authorInfo: B ?? "loading",
      timeString: $,
      edited: e.updatedAt.getTime() !== e.createdAt.getTime(),
      showActions: "hover",
      actions: S,
      className: "bn-thread-comment",
      children: /* @__PURE__ */ i(
        Le,
        {
          autoFocus: c,
          editor: r,
          editable: c,
          actions: e.reactions.length > 0 || c ? ({ isEmpty: E }) => /* @__PURE__ */ v(T, { children: [
            e.reactions.length > 0 && !c && /* @__PURE__ */ v(
              l.Generic.Badge.Group,
              {
                className: R(
                  "bn-badge-group",
                  "bn-comment-reactions"
                ),
                children: [
                  e.reactions.map((F) => /* @__PURE__ */ i(
                    To,
                    {
                      comment: e,
                      emoji: F.emoji,
                      onReactionSelect: H
                    },
                    F.emoji
                  )),
                  /* @__PURE__ */ i(
                    $e,
                    {
                      onEmojiSelect: (F) => H(F.native),
                      children: /* @__PURE__ */ i(
                        l.Generic.Badge.Root,
                        {
                          className: R(
                            "bn-badge",
                            "bn-comment-add-reaction"
                          ),
                          text: "+",
                          icon: /* @__PURE__ */ i(We, { size: 16 }),
                          mainTooltip: o.comments.actions.add_reaction
                        }
                      )
                    }
                  )
                ]
              }
            ),
            c && /* @__PURE__ */ v(
              l.Generic.Toolbar.Root,
              {
                variant: "action-toolbar",
                className: R(
                  "bn-action-toolbar",
                  "bn-comment-actions"
                ),
                children: [
                  /* @__PURE__ */ i(
                    l.Generic.Toolbar.Button,
                    {
                      mainTooltip: "Save",
                      variant: "compact",
                      onClick: h,
                      isDisabled: E,
                      children: "Save"
                    }
                  ),
                  /* @__PURE__ */ i(
                    l.Generic.Toolbar.Button,
                    {
                      className: "bn-button",
                      mainTooltip: "Cancel",
                      variant: "compact",
                      onClick: m,
                      children: "Cancel"
                    }
                  )
                ]
              }
            )
          ] }) : void 0
        }
      )
    }
  );
}, Eo = ({
  thread: e,
  maxCommentsBeforeCollapse: t
}) => {
  const n = C(), o = M(), r = b(), l = Ie(r, e.resolvedBy ? [e.resolvedBy] : []), c = e.comments.map((d, s) => /* @__PURE__ */ i(
    Lo,
    {
      thread: e,
      comment: d,
      showResolveButton: s === 0
    },
    d.id
  ));
  if (e.resolved && e.resolvedUpdatedAt && e.resolvedBy) {
    if (!l.get(e.resolvedBy))
      throw new Error(
        `User ${e.resolvedBy} resolved thread ${e.id}, but their data could not be found.`
      );
    const s = e.comments.findLastIndex(
      (a) => e.resolvedUpdatedAt.getTime() > a.createdAt.getTime()
    ) + 1;
    c.splice(
      s,
      0,
      /* @__PURE__ */ i(
        n.Comments.Comment,
        {
          className: "bn-thread-comment",
          authorInfo: e.resolvedBy && l.get(e.resolvedBy) || "loading",
          timeString: e.resolvedUpdatedAt.toLocaleDateString(void 0, {
            month: "short",
            day: "numeric"
          }),
          edited: !1,
          showActions: !1,
          children: /* @__PURE__ */ i("div", { className: "bn-resolved-text", children: o.comments.sidebar.marked_as_resolved })
        },
        "resolved-comment"
      )
    );
  }
  return t && c.length > t && c.splice(
    1,
    c.length - 2,
    /* @__PURE__ */ i(
      n.Comments.ExpandSectionsPrompt,
      {
        className: "bn-thread-expand-prompt",
        children: o.comments.sidebar.more_replies(e.comments.length - 2)
      },
      "expand-prompt"
    )
  ), c;
}, xt = ({
  thread: e,
  selected: t,
  referenceText: n,
  maxCommentsBeforeCollapse: o,
  onFocus: r,
  onBlur: l,
  tabIndex: c
}) => {
  const d = C(), s = M(), u = b().comments;
  if (!u)
    throw new Error("Comments plugin not found");
  const m = de({
    trailingBlock: !1,
    dictionary: {
      ...s,
      placeholders: {
        emptyDocument: s.placeholders.comment_reply
      }
    },
    schema: Ee,
    sideMenuDetection: "editor"
  }), h = g(async () => {
    await u.threadStore.addComment({
      comment: {
        body: m.document
      },
      threadId: e.id
    }), m.removeBlocks(m.document);
  }, [u, m, e.id]);
  return /* @__PURE__ */ v(
    d.Comments.Card,
    {
      className: "bn-thread",
      headerText: n,
      onFocus: r,
      onBlur: l,
      selected: t,
      tabIndex: c,
      children: [
        /* @__PURE__ */ i(d.Comments.CardSection, { className: "bn-thread-comments", children: /* @__PURE__ */ i(
          Eo,
          {
            thread: e,
            maxCommentsBeforeCollapse: t ? void 0 : o || 5
          }
        ) }),
        t && /* @__PURE__ */ i(d.Comments.CardSection, { className: "bn-thread-composer", children: /* @__PURE__ */ i(
          Le,
          {
            autoFocus: !1,
            editable: !0,
            editor: m,
            actions: ({ isEmpty: f }) => f ? null : /* @__PURE__ */ i(
              d.Generic.Toolbar.Root,
              {
                variant: "action-toolbar",
                className: R(
                  "bn-action-toolbar",
                  "bn-comment-actions"
                ),
                children: /* @__PURE__ */ i(
                  d.Generic.Toolbar.Button,
                  {
                    mainTooltip: "Save",
                    variant: "compact",
                    isDisabled: f,
                    onClick: h,
                    children: "Save"
                  }
                )
              }
            )
          }
        ) })
      ]
    }
  );
};
function yt(e) {
  const t = e.comments;
  if (!t)
    throw new Error("Comments plugin not found");
  const n = t.threadStore, o = N();
  o.current || (o.current = n.getThreads());
  const r = g(
    (l) => n.subscribe((c) => {
      o.current = c, l();
    }),
    [n]
  );
  return ye(r, () => o.current);
}
const Ro = (e) => {
  const t = b();
  if (!t.comments)
    throw new Error(
      "FloatingComposerController can only be used when BlockNote editor has enabled comments"
    );
  const n = O(
    t.comments.onUpdate.bind(t.comments)
  ), { isMounted: o, ref: r, style: l, getFloatingProps: c, setReference: d } = G(!!(n != null && n.selectedThreadId), null, 5e3, {
    placement: "bottom",
    middleware: [A(10), le(), W()],
    onOpenChange: (m) => {
      var h;
      m || ((h = t.comments) == null || h.selectThread(void 0), t.focus());
    },
    ...e.floatingOptions
  }), s = g(() => {
    var h;
    if (!(n != null && n.selectedThreadId))
      return;
    const m = (h = t.domElement) == null ? void 0 : h.querySelector(
      `[data-bn-thread-id="${n == null ? void 0 : n.selectedThreadId}"]`
    );
    m && d(m);
  }, [d, t, n == null ? void 0 : n.selectedThreadId]);
  y(() => {
    if (n != null && n.selectedThreadId)
      return t.onChange(() => {
        s();
      });
  }, [t, s, n == null ? void 0 : n.selectedThreadId]), Gt(s, [s]);
  const a = yt(t);
  if (!o || !n || !n.selectedThreadId)
    return null;
  const u = e.floatingThread || xt;
  return /* @__PURE__ */ i("div", { ref: r, style: l, ...c(), children: /* @__PURE__ */ i(
    u,
    {
      thread: a.get(n.selectedThreadId),
      selected: !0
    }
  ) });
}, _o = (e) => {
  const t = C(), n = M(), { block: o } = e, r = b(), [l, c] = w(""), d = g(
    (u) => {
      c(u.currentTarget.value);
    },
    []
  ), s = g(
    (u) => {
      u.key === "Enter" && (u.preventDefault(), r.updateBlock(o, {
        props: {
          name: Fe(l),
          url: l
        }
      }));
    },
    [r, o, l]
  ), a = g(() => {
    r.updateBlock(o, {
      props: {
        name: Fe(l),
        url: l
      }
    });
  }, [r, o, l]);
  return /* @__PURE__ */ v(t.FilePanel.TabPanel, { className: "bn-tab-panel", children: [
    /* @__PURE__ */ i(
      t.FilePanel.TextInput,
      {
        className: "bn-text-input",
        placeholder: n.file_panel.embed.url_placeholder,
        value: l,
        onChange: d,
        onKeyDown: s,
        "data-test": "embed-input"
      }
    ),
    /* @__PURE__ */ i(
      t.FilePanel.Button,
      {
        className: "bn-button",
        onClick: a,
        "data-test": "embed-input-button",
        children: n.file_panel.embed.embed_button[o.type] || n.file_panel.embed.embed_button.file
      }
    )
  ] });
}, Io = (e) => {
  var m;
  const t = C(), n = M(), { block: o, setLoading: r } = e, l = b(), [c, d] = w(!1);
  y(() => {
    c && setTimeout(() => {
      d(!1);
    }, 3e3);
  }, [c]);
  const s = g(
    (h) => {
      if (h === null)
        return;
      async function f(H) {
        if (r(!0), l.uploadFile !== void 0)
          try {
            let p = await l.uploadFile(H, o.id);
            typeof p == "string" && (p = {
              props: {
                name: H.name,
                url: p
              }
            }), l.updateBlock(o, p);
          } catch {
            d(!0);
          } finally {
            r(!1);
          }
      }
      f(h);
    },
    [o, l, r]
  ), a = l.schema.blockSchema[o.type], u = a.isFileBlock && ((m = a.fileBlockAccept) != null && m.length) ? a.fileBlockAccept.join(",") : "*/*";
  return /* @__PURE__ */ v(t.FilePanel.TabPanel, { className: "bn-tab-panel", children: [
    /* @__PURE__ */ i(
      t.FilePanel.FileInput,
      {
        className: "bn-file-input",
        "data-test": "upload-input",
        accept: u,
        placeholder: n.file_panel.upload.file_placeholder[o.type] || n.file_panel.upload.file_placeholder.file,
        value: null,
        onChange: s
      }
    ),
    c && /* @__PURE__ */ i("div", { className: "bn-error-text", children: n.file_panel.upload.upload_error })
  ] });
}, Bt = (e) => {
  const t = C(), n = M(), o = b(), [r, l] = w(!1), c = e.tabs ?? [
    ...o.uploadFile !== void 0 ? [
      {
        name: n.file_panel.upload.title,
        tabPanel: /* @__PURE__ */ i(Io, { block: e.block, setLoading: l })
      }
    ] : [],
    {
      name: n.file_panel.embed.title,
      tabPanel: /* @__PURE__ */ i(_o, { block: e.block })
    }
  ], [d, s] = w(
    e.defaultOpenTab || c[0].name
  );
  return /* @__PURE__ */ i(
    t.FilePanel.Root,
    {
      className: "bn-panel",
      defaultOpenTab: d,
      openTab: d,
      setOpenTab: s,
      tabs: c,
      loading: r
    }
  );
}, No = (e) => {
  const t = b();
  if (!t.filePanel)
    throw new Error(
      "FileToolbarController can only be used when BlockNote editor schema contains file block"
    );
  const n = O(
    t.filePanel.onUpdate.bind(t.filePanel)
  ), { isMounted: o, ref: r, style: l, getFloatingProps: c } = G(
    (n == null ? void 0 : n.show) || !1,
    (n == null ? void 0 : n.referencePos) || null,
    5e3,
    {
      placement: "bottom",
      middleware: [A(10), W()],
      onOpenChange: (m) => {
        m || (t.filePanel.closeMenu(), t.focus());
      },
      ...e.floatingOptions
    }
  );
  if (!o || !n)
    return null;
  const { show: d, referencePos: s, ...a } = n, u = e.filePanel || Bt;
  return /* @__PURE__ */ i("div", { ref: r, style: l, ...c(), children: /* @__PURE__ */ i(u, { ...a }) });
};
function U(e, t) {
  ue(e, t), se(e, t);
}
function Po(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
function _(e) {
  const t = D();
  if (e || (e = t == null ? void 0 : t.editor), !e)
    throw new Error(
      "'editor' is required, either from BlockNoteContext or as a function argument"
    );
  const n = e, [o, r] = w(() => {
    var l;
    return ((l = n.getSelection()) == null ? void 0 : l.blocks) || [n.getTextCursorPosition().block];
  });
  return U(
    () => {
      var l;
      return r(
        ((l = n.getSelection()) == null ? void 0 : l.blocks) || [n.getTextCursorPosition().block]
      );
    },
    n
  ), o;
}
const Oo = {
  bold: no,
  italic: lo,
  underline: ho,
  strike: uo,
  code: Yn
};
function Do(e, t) {
  return e in t.schema.styleSchema && t.schema.styleSchema[e].type === e && t.schema.styleSchema[e].propSchema === "boolean";
}
const ne = (e) => {
  const t = M(), n = C(), o = b(), r = Do(
    e.basicTextStyle,
    o
  ), l = _(o), [c, d] = w(
    e.basicTextStyle in o.getActiveStyles()
  );
  U(() => {
    r && d(e.basicTextStyle in o.getActiveStyles());
  }, o);
  const s = (m) => {
    if (o.focus(), !!r) {
      if (o.schema.styleSchema[m].propSchema !== "boolean")
        throw new Error("can only toggle boolean styles");
      o.toggleStyles({ [m]: !0 });
    }
  };
  if (!x(() => r ? !!l.find((m) => m.content !== void 0) : !1, [r, l]) || !o.isEditable)
    return null;
  const u = Oo[e.basicTextStyle];
  return /* @__PURE__ */ i(
    n.FormattingToolbar.Button,
    {
      className: "bn-button",
      "data-test": e.basicTextStyle,
      onClick: () => s(e.basicTextStyle),
      isSelected: c,
      label: t.formatting_toolbar[e.basicTextStyle].tooltip,
      mainTooltip: t.formatting_toolbar[e.basicTextStyle].tooltip,
      secondaryTooltip: ce(
        t.formatting_toolbar[e.basicTextStyle].secondary_tooltip,
        t.generic.ctrl_shortcut
      ),
      icon: /* @__PURE__ */ i(u, {})
    }
  );
}, we = (e) => {
  const t = e.textColor || "default", n = e.backgroundColor || "default", o = e.size || 16, r = x(
    () => ({
      pointerEvents: "none",
      fontSize: (o * 0.75).toString() + "px",
      height: o.toString() + "px",
      lineHeight: o.toString() + "px",
      textAlign: "center",
      width: o.toString() + "px"
    }),
    [o]
  );
  return /* @__PURE__ */ i(
    "div",
    {
      className: "bn-color-icon",
      "data-background-color": n,
      "data-text-color": t,
      style: r,
      children: "A"
    }
  );
}, qe = [
  "default",
  "gray",
  "brown",
  "red",
  "orange",
  "yellow",
  "green",
  "blue",
  "purple",
  "pink"
], me = (e) => {
  const t = C(), n = M();
  return /* @__PURE__ */ v(T, { children: [
    /* @__PURE__ */ i(() => e.text ? /* @__PURE__ */ v(T, { children: [
      /* @__PURE__ */ i(t.Generic.Menu.Label, { children: n.color_picker.text_title }),
      qe.map((l) => /* @__PURE__ */ i(
        t.Generic.Menu.Item,
        {
          onClick: () => {
            e.onClick && e.onClick(), e.text.setColor(l);
          },
          "data-test": "text-color-" + l,
          icon: /* @__PURE__ */ i(we, { textColor: l, size: e.iconSize }),
          checked: e.text.color === l,
          children: n.color_picker.colors[l]
        },
        "text-color-" + l
      ))
    ] }) : null, {}),
    /* @__PURE__ */ i(() => e.background ? /* @__PURE__ */ v(T, { children: [
      /* @__PURE__ */ i(t.Generic.Menu.Label, { children: n.color_picker.background_title }),
      qe.map((l) => /* @__PURE__ */ i(
        t.Generic.Menu.Item,
        {
          onClick: () => {
            e.onClick && e.onClick(), e.background.setColor(l);
          },
          "data-test": "background-color-" + l,
          icon: /* @__PURE__ */ i(we, { backgroundColor: l, size: e.iconSize }),
          checked: e.background.color === l,
          children: n.color_picker.colors[l]
        },
        "background-color-" + l
      ))
    ] }) : null, {})
  ] });
};
function Ke(e, t) {
  return `${e}Color` in t.schema.styleSchema && t.schema.styleSchema[`${e}Color`].type === `${e}Color` && t.schema.styleSchema[`${e}Color`].propSchema === "string";
}
const Zo = () => {
  const e = C(), t = M(), n = b(), o = Ke("text", n), r = Ke("background", n), l = _(n), [c, d] = w(
    o && n.getActiveStyles().textColor || "default"
  ), [s, a] = w(
    r && n.getActiveStyles().backgroundColor || "default"
  );
  U(() => {
    o && d(n.getActiveStyles().textColor || "default"), r && a(
      n.getActiveStyles().backgroundColor || "default"
    );
  }, n);
  const u = g(
    (f) => {
      if (!o)
        throw Error(
          "Tried to set text color, but style does not exist in editor schema."
        );
      f === "default" ? n.removeStyles({ textColor: f }) : n.addStyles({ textColor: f }), setTimeout(() => {
        n.focus();
      });
    },
    [n, o]
  ), m = g(
    (f) => {
      if (!r)
        throw Error(
          "Tried to set background color, but style does not exist in editor schema."
        );
      f === "default" ? n.removeStyles({ backgroundColor: f }) : n.addStyles({ backgroundColor: f }), setTimeout(() => {
        n.focus();
      });
    },
    [r, n]
  );
  return !x(() => {
    if (!o && !r)
      return !1;
    for (const f of l)
      if (f.content !== void 0)
        return !0;
    return !1;
  }, [r, l, o]) || !n.isEditable ? null : /* @__PURE__ */ v(e.Generic.Menu.Root, { children: [
    /* @__PURE__ */ i(e.Generic.Menu.Trigger, { children: /* @__PURE__ */ i(
      e.FormattingToolbar.Button,
      {
        className: "bn-button",
        "data-test": "colors",
        label: t.formatting_toolbar.colors.tooltip,
        mainTooltip: t.formatting_toolbar.colors.tooltip,
        icon: /* @__PURE__ */ i(
          we,
          {
            textColor: c,
            backgroundColor: s,
            size: 20
          }
        )
      }
    ) }),
    /* @__PURE__ */ i(
      e.Generic.Menu.Dropdown,
      {
        className: "bn-menu-dropdown bn-color-picker-dropdown",
        children: /* @__PURE__ */ i(
          me,
          {
            text: o ? {
              color: c,
              setColor: u
            } : void 0,
            background: r ? {
              color: s,
              setColor: m
            } : void 0
          }
        )
      }
    )
  ] });
}, Xe = (e) => {
  for (const t of Qt)
    if (e.startsWith(t))
      return e;
  return `${en}://${e}`;
}, Vt = (e) => {
  const t = C(), n = M(), { url: o, text: r, editLink: l, showTextField: c } = e, [d, s] = w(o), [a, u] = w(r);
  y(() => {
    s(o), u(r);
  }, [r, o]);
  const m = g(
    (p) => {
      p.key === "Enter" && (p.preventDefault(), l(Xe(d), a));
    },
    [l, d, a]
  ), h = g(
    (p) => s(p.currentTarget.value),
    []
  ), f = g(
    (p) => u(p.currentTarget.value),
    []
  ), H = g(
    () => l(Xe(d), a),
    [l, d, a]
  );
  return /* @__PURE__ */ v(t.Generic.Form.Root, { children: [
    /* @__PURE__ */ i(
      t.Generic.Form.TextInput,
      {
        className: "bn-text-input",
        name: "url",
        icon: /* @__PURE__ */ i(Ct, {}),
        autoFocus: !0,
        placeholder: n.link_toolbar.form.url_placeholder,
        value: d,
        onKeyDown: m,
        onChange: h,
        onSubmit: H
      }
    ),
    c !== !1 && /* @__PURE__ */ i(
      t.Generic.Form.TextInput,
      {
        className: "bn-text-input",
        name: "title",
        icon: /* @__PURE__ */ i(_e, {}),
        placeholder: n.link_toolbar.form.title_placeholder,
        value: a,
        onKeyDown: m,
        onChange: f,
        onSubmit: H
      }
    )
  ] });
};
function Fo(e) {
  return "link" in e.schema.inlineContentSchema && e.schema.inlineContentSchema.link === "link";
}
const Ao = () => {
  var H;
  const e = b(), t = C(), n = M(), o = Fo(e), r = _(e), [l, c] = w(!1), [d, s] = w(e.getSelectedLinkUrl() || ""), [a, u] = w(e.getSelectedText());
  U(() => {
    u(e.getSelectedText() || ""), s(e.getSelectedLinkUrl() || "");
  }, e), y(() => {
    var V;
    const p = (B) => {
      (B.ctrlKey || B.metaKey) && B.key === "k" && (c(!0), B.preventDefault());
    };
    return (V = e.prosemirrorView) == null || V.dom.addEventListener("keydown", p), () => {
      var B;
      (B = e.prosemirrorView) == null || B.dom.removeEventListener("keydown", p);
    };
  }, [(H = e.prosemirrorView) == null ? void 0 : H.dom]);
  const m = g(
    (p) => {
      e.createLink(p), e.focus();
    },
    [e]
  ), h = e.transact(
    (p) => tn(p.selection)
  );
  return !x(() => {
    if (!o)
      return !1;
    for (const p of r)
      if (p.content === void 0)
        return !1;
    return !h;
  }, [o, r, h]) || !("link" in e.schema.inlineContentSchema) || !e.isEditable ? null : /* @__PURE__ */ v(t.Generic.Popover.Root, { opened: l, children: [
    /* @__PURE__ */ i(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ i(
      t.FormattingToolbar.Button,
      {
        className: "bn-button",
        "data-test": "createLink",
        label: n.formatting_toolbar.link.tooltip,
        mainTooltip: n.formatting_toolbar.link.tooltip,
        secondaryTooltip: ce(
          n.formatting_toolbar.link.secondary_tooltip,
          n.generic.ctrl_shortcut
        ),
        icon: /* @__PURE__ */ i(Ct, {}),
        onClick: () => c(!0)
      }
    ) }),
    /* @__PURE__ */ i(
      t.Generic.Popover.Content,
      {
        className: "bn-popover-content bn-form-popover",
        variant: "form-popover",
        children: /* @__PURE__ */ i(
          Vt,
          {
            url: d,
            text: a,
            editLink: m,
            showTextField: !1
          }
        )
      }
    )
  ] });
}, Go = () => {
  const e = M(), t = C(), n = b(), [o, r] = w(), l = _(n), c = x(() => {
    if (l.length !== 1)
      return;
    const a = l[0];
    if (J(a, n))
      return r(a.props.caption), a;
  }, [n, l]), d = g(
    (a) => {
      c && a.key === "Enter" && (a.preventDefault(), n.updateBlock(c, {
        props: {
          caption: o
          // TODO
        }
      }));
    },
    [o, n, c]
  ), s = g(
    (a) => r(a.currentTarget.value),
    []
  );
  return !c || Q(c, n) || !n.isEditable ? null : /* @__PURE__ */ v(t.Generic.Popover.Root, { children: [
    /* @__PURE__ */ i(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ i(
      t.FormattingToolbar.Button,
      {
        className: "bn-button",
        label: e.formatting_toolbar.file_caption.tooltip,
        mainTooltip: e.formatting_toolbar.file_caption.tooltip,
        icon: /* @__PURE__ */ i(je, {}),
        isSelected: c.props.caption !== ""
      }
    ) }),
    /* @__PURE__ */ i(
      t.Generic.Popover.Content,
      {
        className: "bn-popover-content bn-form-popover",
        variant: "form-popover",
        children: /* @__PURE__ */ i(t.Generic.Form.Root, { children: /* @__PURE__ */ i(
          t.Generic.Form.TextInput,
          {
            name: "file-caption",
            icon: /* @__PURE__ */ i(je, {}),
            value: o || "",
            autoFocus: !0,
            placeholder: e.formatting_toolbar.file_caption.input_placeholder,
            onKeyDown: d,
            onChange: s
          }
        ) })
      }
    )
  ] });
}, Uo = () => {
  const e = M(), t = C(), n = b(), o = _(n), r = x(() => {
    if (o.length !== 1)
      return;
    const c = o[0];
    if (J(c, n))
      return c;
  }, [n, o]), l = g(() => {
    n.focus(), n.removeBlocks([r]);
  }, [n, r]);
  return !r || Q(r, n) || !n.isEditable ? null : /* @__PURE__ */ i(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      label: e.formatting_toolbar.file_delete.tooltip[r.type] || e.formatting_toolbar.file_delete.tooltip.file,
      mainTooltip: e.formatting_toolbar.file_delete.tooltip[r.type] || e.formatting_toolbar.file_delete.tooltip.file,
      icon: /* @__PURE__ */ i(wo, {}),
      onClick: l
    }
  );
}, zo = () => {
  const e = M(), t = C(), n = b(), [o, r] = w(), l = _(n), c = x(() => {
    if (l.length !== 1)
      return;
    const a = l[0];
    if (J(a, n))
      return r(a.props.name), a;
  }, [n, l]), d = g(
    (a) => {
      c && a.key === "Enter" && (a.preventDefault(), n.updateBlock(c, {
        props: {
          name: o
          // TODO
        }
      }));
    },
    [o, n, c]
  ), s = g(
    (a) => r(a.currentTarget.value),
    []
  );
  return !c || Q(c, n) || !n.isEditable ? null : /* @__PURE__ */ v(t.Generic.Popover.Root, { children: [
    /* @__PURE__ */ i(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ i(
      t.FormattingToolbar.Button,
      {
        className: "bn-button",
        label: e.formatting_toolbar.file_rename.tooltip[c.type] || e.formatting_toolbar.file_rename.tooltip.file,
        mainTooltip: e.formatting_toolbar.file_rename.tooltip[c.type] || e.formatting_toolbar.file_rename.tooltip.file,
        icon: /* @__PURE__ */ i(ze, {})
      }
    ) }),
    /* @__PURE__ */ i(
      t.Generic.Popover.Content,
      {
        className: "bn-popover-content bn-form-popover",
        variant: "form-popover",
        children: /* @__PURE__ */ i(t.Generic.Form.Root, { children: /* @__PURE__ */ i(
          t.Generic.Form.TextInput,
          {
            name: "file-name",
            icon: /* @__PURE__ */ i(ze, {}),
            value: o || "",
            autoFocus: !0,
            placeholder: e.formatting_toolbar.file_rename.input_placeholder[c.type] || e.formatting_toolbar.file_rename.input_placeholder.file,
            onKeyDown: d,
            onChange: s
          }
        ) })
      }
    )
  ] });
}, jo = () => {
  const e = M(), t = C(), n = b(), o = _(n), [r, l] = w(!1);
  y(() => {
    l(!1);
  }, [o]);
  const c = o.length === 1 ? o[0] : void 0;
  return c === void 0 || !J(c, n) || !n.isEditable ? null : /* @__PURE__ */ v(t.Generic.Popover.Root, { opened: r, position: "bottom", children: [
    /* @__PURE__ */ i(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ i(
      t.FormattingToolbar.Button,
      {
        className: "bn-button",
        onClick: () => l(!r),
        isSelected: r,
        mainTooltip: e.formatting_toolbar.file_replace.tooltip[c.type] || e.formatting_toolbar.file_replace.tooltip.file,
        label: e.formatting_toolbar.file_replace.tooltip[c.type] || e.formatting_toolbar.file_replace.tooltip.file,
        icon: /* @__PURE__ */ i(bo, {})
      }
    ) }),
    /* @__PURE__ */ i(
      t.Generic.Popover.Content,
      {
        className: "bn-popover-content bn-panel-popover",
        variant: "panel-popover",
        children: /* @__PURE__ */ i(Bt, { block: c })
      }
    )
  ] });
}, Wo = () => {
  const e = M(), t = C(), n = b(), o = _(n), [r, l] = w(
    () => n.canNestBlock()
  );
  U(() => {
    l(n.canNestBlock());
  }, n);
  const c = g(() => {
    n.focus(), n.nestBlock();
  }, [n]);
  return !x(() => !o.find(
    (s) => n.schema.blockSchema[s.type].content !== "inline"
  ), [n.schema.blockSchema, o]) || !n.isEditable ? null : /* @__PURE__ */ i(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      "data-test": "nestBlock",
      onClick: c,
      isDisabled: !r,
      label: e.formatting_toolbar.nest.tooltip,
      mainTooltip: e.formatting_toolbar.nest.tooltip,
      secondaryTooltip: ce(
        e.formatting_toolbar.nest.secondary_tooltip,
        e.generic.ctrl_shortcut
      ),
      icon: /* @__PURE__ */ i(io, {})
    }
  );
}, $o = () => {
  const e = M(), t = C(), n = b(), o = _(n), [r, l] = w(
    () => n.canUnnestBlock()
  );
  U(() => {
    l(n.canUnnestBlock());
  }, n);
  const c = g(() => {
    n.focus(), n.unnestBlock();
  }, [n]);
  return !x(() => !o.find(
    (s) => n.schema.blockSchema[s.type].content !== "inline"
  ), [n.schema.blockSchema, o]) || !n.isEditable ? null : /* @__PURE__ */ i(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      "data-test": "unnestBlock",
      onClick: c,
      isDisabled: !r,
      label: e.formatting_toolbar.unnest.tooltip,
      mainTooltip: e.formatting_toolbar.unnest.tooltip,
      secondaryTooltip: ce(
        e.formatting_toolbar.unnest.secondary_tooltip,
        e.generic.ctrl_shortcut
      ),
      icon: /* @__PURE__ */ i(ro, {})
    }
  );
}, qo = (e) => [
  {
    name: e.slash_menu.paragraph.title,
    type: "paragraph",
    icon: _e,
    isSelected: (t) => t.type === "paragraph"
  },
  {
    name: e.slash_menu.heading.title,
    type: "heading",
    props: { level: 1 },
    icon: ft,
    isSelected: (t) => t.type === "heading" && "level" in t.props && t.props.level === 1
  },
  {
    name: e.slash_menu.heading_2.title,
    type: "heading",
    props: { level: 2 },
    icon: gt,
    isSelected: (t) => t.type === "heading" && "level" in t.props && t.props.level === 2
  },
  {
    name: e.slash_menu.heading_3.title,
    type: "heading",
    props: { level: 3 },
    icon: bt,
    isSelected: (t) => t.type === "heading" && "level" in t.props && t.props.level === 3
  },
  {
    name: e.slash_menu.quote.title,
    type: "quote",
    icon: vt,
    isSelected: (t) => t.type === "quote"
  },
  {
    name: e.slash_menu.bullet_list.title,
    type: "bulletListItem",
    icon: wt,
    isSelected: (t) => t.type === "bulletListItem"
  },
  {
    name: e.slash_menu.numbered_list.title,
    type: "numberedListItem",
    icon: kt,
    isSelected: (t) => t.type === "numberedListItem"
  },
  {
    name: e.slash_menu.check_list.title,
    type: "checkListItem",
    icon: pt,
    isSelected: (t) => t.type === "checkListItem"
  }
], Ko = (e) => {
  const t = C(), n = M(), o = b(), r = _(o), [l, c] = w(o.getTextCursorPosition().block), d = x(() => (e.items || qo(n)).filter(
    (u) => u.type in o.schema.blockSchema
  ), [o, n, e.items]), s = x(
    () => d.find((u) => u.type === l.type) !== void 0,
    [l.type, d]
  ), a = x(() => {
    const u = (m) => {
      o.focus(), o.transact(() => {
        for (const h of r)
          o.updateBlock(h, {
            type: m.type,
            props: m.props
          });
      });
    };
    return d.map((m) => {
      const h = m.icon;
      return {
        text: m.name,
        icon: /* @__PURE__ */ i(h, { size: 16 }),
        onClick: () => u(m),
        isSelected: m.isSelected(l)
      };
    });
  }, [l, d, o, r]);
  return U(() => {
    c(o.getTextCursorPosition().block);
  }, o), !s || !o.isEditable ? null : /* @__PURE__ */ i(
    t.FormattingToolbar.Select,
    {
      className: "bn-select",
      items: a
    }
  );
}, Xo = () => {
  const e = M(), t = C(), n = b(), o = g(() => {
    var r;
    (r = n.comments) == null || r.startPendingComment(), n.formattingToolbar.closeMenu();
  }, [n]);
  return n.comments ? /* @__PURE__ */ i(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      label: e.formatting_toolbar.comment.tooltip,
      mainTooltip: e.formatting_toolbar.comment.tooltip,
      icon: /* @__PURE__ */ i(ht, {}),
      onClick: o
    }
  ) : null;
}, Yo = () => {
  const e = M(), t = C(), n = b(), o = g(() => {
    n._tiptapEditor.chain().focus().addPendingComment().run();
  }, [n]);
  return (
    // We manually check if a comment extension (like liveblocks) is installed
    // By adding default support for this, the user doesn't need to customize the formatting toolbar
    !n._tiptapEditor.commands.addPendingComment || !n.isEditable ? null : /* @__PURE__ */ i(
      t.FormattingToolbar.Button,
      {
        className: "bn-button",
        label: e.formatting_toolbar.comment.tooltip,
        mainTooltip: e.formatting_toolbar.comment.tooltip,
        icon: /* @__PURE__ */ i(ht, {}),
        onClick: o
      }
    )
  );
};
function ve(e, t) {
  try {
    const n = new URL(e, t);
    if (n.protocol !== "javascript:")
      return n.href;
  } catch {
  }
  return "#";
}
const Jo = () => {
  const e = M(), t = C(), n = b(), o = _(n), r = x(() => {
    if (o.length !== 1)
      return;
    const c = o[0];
    if (J(c, n))
      return c;
  }, [n, o]), l = g(() => {
    r && r.props.url && (n.focus(), n.resolveFileUrl ? n.resolveFileUrl(r.props.url).then(
      (c) => window.open(ve(c, window.location.href))
    ) : window.open(ve(r.props.url, window.location.href)));
  }, [n, r]);
  return !r || Q(r, n) ? null : /* @__PURE__ */ i(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      label: e.formatting_toolbar.file_download.tooltip[r.type] || e.formatting_toolbar.file_download.tooltip.file,
      mainTooltip: e.formatting_toolbar.file_download.tooltip[r.type] || e.formatting_toolbar.file_download.tooltip.file,
      icon: /* @__PURE__ */ i(Ho, {}),
      onClick: l
    }
  );
}, Qo = () => {
  const e = M(), t = C(), n = b(), o = _(n), r = x(() => {
    if (o.length !== 1)
      return;
    const c = o[0];
    if (nn(c, n))
      return c;
  }, [n, o]), l = g(() => {
    r && n.updateBlock(r, {
      props: {
        showPreview: !r.props.showPreview
        // TODO
      }
    });
  }, [n, r]);
  return !r || Q(r, n) || !n.isEditable ? null : /* @__PURE__ */ i(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      label: "Toggle preview",
      mainTooltip: e.formatting_toolbar.file_preview_toggle.tooltip,
      icon: /* @__PURE__ */ i(go, {}),
      isSelected: r.props.showPreview,
      onClick: l
    }
  );
}, er = () => {
  const e = M(), t = C(), n = b(), o = _(n), r = x(() => {
    var d;
    if (o.length !== 1)
      return;
    const c = o[0];
    if (c.type === "table")
      return (d = n.tableHandles) == null ? void 0 : d.getMergeDirection(c);
  }, [n, o]), l = g(() => {
    var c;
    (c = n.tableHandles) == null || c.mergeCells();
  }, [n]);
  return !n.isEditable || r === void 0 || !n.settings.tables.splitCells ? null : /* @__PURE__ */ i(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      label: e.formatting_toolbar.table_cell_merge.tooltip,
      mainTooltip: e.formatting_toolbar.table_cell_merge.tooltip,
      icon: r === "horizontal" ? /* @__PURE__ */ i(ao, {}) : /* @__PURE__ */ i(so, {}),
      onClick: l
    }
  );
}, tr = {
  left: eo,
  center: Jn,
  right: to,
  justify: Qn
}, be = (e) => {
  const t = C(), n = M(), o = b(), r = _(o), l = x(() => {
    var u;
    const a = r[0];
    if (ke("textAlignment", a, o))
      return a.props.textAlignment;
    if (a.type === "table") {
      const m = (u = o.tableHandles) == null ? void 0 : u.getCellSelection();
      if (!m)
        return;
      const h = m.cells.map(
        ({ row: H, col: p }) => K(
          a.content.rows[H].cells[p]
        ).props.textAlignment
      ), f = h[0];
      if (h.every((H) => H === f))
        return f;
    }
  }, [o, r]), c = g(
    (a) => {
      var u;
      o.focus();
      for (const m of r)
        if (q("textAlignment", m.type, o))
          o.updateBlock(m, {
            props: { textAlignment: a }
          });
        else if (m.type === "table") {
          const h = (u = o.tableHandles) == null ? void 0 : u.getCellSelection();
          if (!h)
            continue;
          const f = m.content.rows.map(
            (H) => ({
              ...H,
              cells: H.cells.map((p) => K(p))
            })
          );
          h.cells.forEach(({ row: H, col: p }) => {
            f[H].cells[p].props.textAlignment = a;
          }), o.updateBlock(m, {
            type: "table",
            content: {
              ...m.content,
              type: "tableContent",
              rows: f
            }
          }), o.setTextCursorPosition(m);
        }
    },
    [o, r]
  );
  if (!x(() => !!r.find(
    (a) => "textAlignment" in a.props || a.type === "table" && a.children
  ), [r]) || !o.isEditable)
    return null;
  const s = tr[e.textAlignment];
  return /* @__PURE__ */ i(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      "data-test": `alignText${e.textAlignment.slice(0, 1).toUpperCase() + e.textAlignment.slice(1)}`,
      onClick: () => c(e.textAlignment),
      isSelected: l === e.textAlignment,
      label: n.formatting_toolbar[`align_${e.textAlignment}`].tooltip,
      mainTooltip: n.formatting_toolbar[`align_${e.textAlignment}`].tooltip,
      icon: /* @__PURE__ */ i(s, {})
    }
  );
}, nr = (e) => [
  /* @__PURE__ */ i(Ko, { items: e }, "blockTypeSelect"),
  /* @__PURE__ */ i(er, {}, "tableCellMergeButton"),
  /* @__PURE__ */ i(Go, {}, "fileCaptionButton"),
  /* @__PURE__ */ i(jo, {}, "replaceFileButton"),
  /* @__PURE__ */ i(zo, {}, "fileRenameButton"),
  /* @__PURE__ */ i(Uo, {}, "fileDeleteButton"),
  /* @__PURE__ */ i(Jo, {}, "fileDownloadButton"),
  /* @__PURE__ */ i(Qo, {}, "filePreviewButton"),
  /* @__PURE__ */ i(ne, { basicTextStyle: "bold" }, "boldStyleButton"),
  /* @__PURE__ */ i(ne, { basicTextStyle: "italic" }, "italicStyleButton"),
  /* @__PURE__ */ i(
    ne,
    {
      basicTextStyle: "underline"
    },
    "underlineStyleButton"
  ),
  /* @__PURE__ */ i(ne, { basicTextStyle: "strike" }, "strikeStyleButton"),
  /* @__PURE__ */ i(be, { textAlignment: "left" }, "textAlignLeftButton"),
  /* @__PURE__ */ i(be, { textAlignment: "center" }, "textAlignCenterButton"),
  /* @__PURE__ */ i(be, { textAlignment: "right" }, "textAlignRightButton"),
  /* @__PURE__ */ i(Zo, {}, "colorStyleButton"),
  /* @__PURE__ */ i(Wo, {}, "nestBlockButton"),
  /* @__PURE__ */ i($o, {}, "unnestBlockButton"),
  /* @__PURE__ */ i(Ao, {}, "createLinkButton"),
  /* @__PURE__ */ i(Xo, {}, "addCommentButton"),
  /* @__PURE__ */ i(Yo, {}, "addTiptapCommentButton")
], St = (e) => {
  const t = C();
  return /* @__PURE__ */ i(
    t.FormattingToolbar.Root,
    {
      className: "bn-toolbar bn-formatting-toolbar",
      children: e.children || nr(e.blockTypeSelectItems)
    }
  );
}, Ye = (e) => {
  switch (e) {
    case "left":
      return "top-start";
    case "center":
      return "top";
    case "right":
      return "top-end";
    default:
      return "top-start";
  }
}, or = (e) => {
  const t = N(null), n = b(), [o, r] = w(
    () => {
      const h = n.getTextCursorPosition().block;
      return "textAlignment" in h.props ? Ye(
        h.props.textAlignment
      ) : "top-start";
    }
  );
  U(() => {
    const h = n.getTextCursorPosition().block;
    "textAlignment" in h.props ? r(
      Ye(
        h.props.textAlignment
      )
    ) : r("top-start");
  }, n);
  const l = O(
    n.formattingToolbar.onUpdate.bind(n.formattingToolbar)
  ), { isMounted: c, ref: d, style: s, getFloatingProps: a } = G(
    (l == null ? void 0 : l.show) || !1,
    (l == null ? void 0 : l.referencePos) || null,
    3e3,
    {
      placement: o,
      middleware: [A(10), le(), W()],
      onOpenChange: (h, f) => {
        h || (n.formattingToolbar.closeMenu(), n.focus());
      },
      ...e.floatingOptions
    }
  ), u = x(() => Po([t, d]), [t, d]);
  if (!c || !l)
    return null;
  if (!l.show && t.current)
    return /* @__PURE__ */ i(
      "div",
      {
        ref: u,
        style: s,
        dangerouslySetInnerHTML: { __html: t.current.innerHTML }
      }
    );
  const m = e.formattingToolbar || St;
  return /* @__PURE__ */ i("div", { ref: u, style: s, ...a(), children: /* @__PURE__ */ i(m, {}) });
}, rr = (e) => {
  const t = C(), n = M();
  return /* @__PURE__ */ i(
    t.LinkToolbar.Button,
    {
      className: "bn-button",
      label: n.link_toolbar.delete.tooltip,
      mainTooltip: n.link_toolbar.delete.tooltip,
      isSelected: !1,
      onClick: e.deleteLink,
      icon: /* @__PURE__ */ i(co, {})
    }
  );
}, ir = (e) => {
  const t = C(), n = M();
  return /* @__PURE__ */ v(t.Generic.Popover.Root, { children: [
    /* @__PURE__ */ i(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ i(
      t.LinkToolbar.Button,
      {
        className: "bn-button",
        mainTooltip: n.link_toolbar.edit.tooltip,
        isSelected: !1,
        children: n.link_toolbar.edit.text
      }
    ) }),
    /* @__PURE__ */ i(
      t.Generic.Popover.Content,
      {
        className: "bn-popover-content bn-form-popover",
        variant: "form-popover",
        children: /* @__PURE__ */ i(Vt, { ...e })
      }
    )
  ] });
}, lr = (e) => {
  const t = C(), n = M();
  return /* @__PURE__ */ i(
    t.LinkToolbar.Button,
    {
      className: "bn-button",
      mainTooltip: n.link_toolbar.open.tooltip,
      label: n.link_toolbar.open.tooltip,
      isSelected: !1,
      onClick: () => {
        window.open(ve(e.url, window.location.href), "_blank");
      },
      icon: /* @__PURE__ */ i(Mo, {})
    }
  );
}, cr = (e) => {
  const t = C();
  return e.children ? /* @__PURE__ */ i(t.LinkToolbar.Root, { className: "bn-toolbar bn-link-toolbar", children: e.children }) : /* @__PURE__ */ v(
    t.LinkToolbar.Root,
    {
      className: "bn-toolbar bn-link-toolbar",
      onMouseEnter: e.stopHideTimer,
      onMouseLeave: e.startHideTimer,
      children: [
        /* @__PURE__ */ i(
          ir,
          {
            url: e.url,
            text: e.text,
            editLink: e.editLink
          }
        ),
        /* @__PURE__ */ i(lr, { url: e.url }),
        /* @__PURE__ */ i(rr, { deleteLink: e.deleteLink })
      ]
    }
  );
}, ar = (e) => {
  const t = b(), n = {
    deleteLink: t.linkToolbar.deleteLink,
    editLink: t.linkToolbar.editLink,
    startHideTimer: t.linkToolbar.startHideTimer,
    stopHideTimer: t.linkToolbar.stopHideTimer
  }, o = O(
    t.linkToolbar.onUpdate.bind(t.linkToolbar)
  ), { isMounted: r, ref: l, style: c, getFloatingProps: d } = G(
    (o == null ? void 0 : o.show) || !1,
    (o == null ? void 0 : o.referencePos) || null,
    4e3,
    {
      placement: "top-start",
      middleware: [A(10), W()],
      onOpenChange: (h) => {
        h || (t.linkToolbar.closeMenu(), t.focus());
      },
      ...e.floatingOptions
    }
  );
  if (!r || !o)
    return null;
  const { show: s, referencePos: a, ...u } = o, m = e.linkToolbar || cr;
  return /* @__PURE__ */ i("div", { ref: l, style: c, ...d(), children: /* @__PURE__ */ i(m, { ...u, ...n }) });
};
function sr(e) {
  return k({ attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8Z" }, child: [] }, { tag: "path", attr: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8Z" }, child: [] }] })(e);
}
const dr = (e) => {
  const t = C(), n = M(), o = b(), r = g(() => {
    const l = e.block.content;
    if (l !== void 0 && Array.isArray(l) && l.length === 0)
      o.setTextCursorPosition(e.block), o.openSuggestionMenu("/");
    else {
      const d = o.insertBlocks(
        [{ type: "paragraph" }],
        e.block,
        "after"
      )[0];
      o.setTextCursorPosition(d), o.openSuggestionMenu("/");
    }
  }, [o, e.block]);
  return /* @__PURE__ */ i(
    t.SideMenu.Button,
    {
      className: "bn-button",
      label: n.side_menu.add_block_label,
      icon: /* @__PURE__ */ i(sr, { size: 24, onClick: r, "data-test": "dragHandleAdd" })
    }
  );
};
function Tt(e) {
  return k({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" }, child: [] }, { tag: "path", attr: { d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" }, child: [] }] })(e);
}
function ur(e) {
  return k({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "m7 10 5 5 5-5z" }, child: [] }] })(e);
}
const mr = (e) => {
  const t = C(), n = b();
  return !q("textColor", e.block.type, n) && !q("backgroundColor", e.block.type, n) ? null : /* @__PURE__ */ v(t.Generic.Menu.Root, { position: "right", sub: !0, children: [
    /* @__PURE__ */ i(t.Generic.Menu.Trigger, { sub: !0, children: /* @__PURE__ */ i(
      t.Generic.Menu.Item,
      {
        className: "bn-menu-item",
        subTrigger: !0,
        children: e.children
      }
    ) }),
    /* @__PURE__ */ i(
      t.Generic.Menu.Dropdown,
      {
        sub: !0,
        className: "bn-menu-dropdown bn-color-picker-dropdown",
        children: /* @__PURE__ */ i(
          me,
          {
            iconSize: 18,
            text: q(
              "textColor",
              e.block.type,
              n
            ) && ke("textColor", e.block, n) ? {
              color: e.block.props.textColor,
              setColor: (o) => n.updateBlock(e.block, {
                type: e.block.type,
                props: { textColor: o }
              })
            } : void 0,
            background: q(
              "backgroundColor",
              e.block.type,
              n
            ) && ke("backgroundColor", e.block, n) ? {
              color: e.block.props.backgroundColor,
              setColor: (o) => n.updateBlock(e.block, {
                props: { backgroundColor: o }
              })
            } : void 0
          }
        )
      }
    )
  ] });
}, hr = (e) => {
  const t = C(), n = b();
  return /* @__PURE__ */ i(
    t.Generic.Menu.Item,
    {
      className: "bn-menu-item",
      onClick: () => n.removeBlocks([e.block]),
      children: e.children
    }
  );
}, fr = (e) => {
  const t = C(), n = b();
  if (e.block.type !== "table" || !n.settings.tables.headers)
    return null;
  const o = !!e.block.content.headerRows;
  return /* @__PURE__ */ i(
    t.Generic.Menu.Item,
    {
      className: "bn-menu-item",
      checked: o,
      onClick: () => {
        const r = n.getBlock(e.block.id);
        r && n.updateBlock(r, {
          ...r,
          content: {
            ...r.content,
            headerRows: o ? void 0 : 1
          }
        });
      },
      children: e.children
    }
  );
}, gr = (e) => {
  const t = C(), n = b();
  if (e.block.type !== "table" || !n.settings.tables.headers)
    return null;
  const o = !!e.block.content.headerCols;
  return /* @__PURE__ */ i(
    t.Generic.Menu.Item,
    {
      className: "bn-menu-item",
      checked: o,
      onClick: () => {
        n.updateBlock(e.block, {
          type: "table",
          content: {
            ...e.block.content,
            type: "tableContent",
            headerCols: o ? void 0 : 1
          }
        });
      },
      children: e.children
    }
  );
}, br = (e) => {
  const t = C(), n = M();
  return /* @__PURE__ */ i(
    t.Generic.Menu.Dropdown,
    {
      className: "bn-menu-dropdown bn-drag-handle-menu",
      children: e.children || /* @__PURE__ */ v(T, { children: [
        /* @__PURE__ */ i(hr, { ...e, children: n.drag_handle.delete_menuitem }),
        /* @__PURE__ */ i(mr, { ...e, children: n.drag_handle.colors_menuitem }),
        /* @__PURE__ */ i(fr, { ...e, children: n.drag_handle.header_row_menuitem }),
        /* @__PURE__ */ i(gr, { ...e, children: n.drag_handle.header_column_menuitem })
      ] })
    }
  );
}, Cr = (e) => {
  const t = C(), n = M(), o = e.dragHandleMenu || br;
  return /* @__PURE__ */ v(
    t.Generic.Menu.Root,
    {
      onOpenChange: (r) => {
        r ? e.freezeMenu() : e.unfreezeMenu();
      },
      position: "left",
      children: [
        /* @__PURE__ */ i(t.Generic.Menu.Trigger, { children: /* @__PURE__ */ i(
          t.SideMenu.Button,
          {
            label: n.side_menu.drag_handle_label,
            draggable: !0,
            onDragStart: (r) => e.blockDragStart(r, e.block),
            onDragEnd: e.blockDragEnd,
            className: "bn-button",
            icon: /* @__PURE__ */ i(Tt, { size: 24, "data-test": "dragHandle" })
          }
        ) }),
        /* @__PURE__ */ i(o, { block: e.block, children: e.children })
      ]
    }
  );
}, pr = (e) => {
  const t = C(), n = x(() => {
    const o = {
      "data-block-type": e.block.type
    };
    return e.block.type === "heading" && (o["data-level"] = e.block.props.level.toString()), e.editor.schema.blockSchema[e.block.type].isFileBlock && (e.block.props.url ? o["data-url"] = "true" : o["data-url"] = "false"), o;
  }, [e.block, e.editor.schema.blockSchema]);
  return /* @__PURE__ */ i(t.SideMenu.Root, { className: "bn-side-menu", ...n, children: e.children || /* @__PURE__ */ v(T, { children: [
    /* @__PURE__ */ i(dr, { ...e }),
    /* @__PURE__ */ i(Cr, { ...e })
  ] }) });
}, kr = (e) => {
  const t = b(), n = {
    blockDragStart: t.sideMenu.blockDragStart,
    blockDragEnd: t.sideMenu.blockDragEnd,
    freezeMenu: t.sideMenu.freezeMenu,
    unfreezeMenu: t.sideMenu.unfreezeMenu
  }, o = O(
    t.sideMenu.onUpdate.bind(t.sideMenu)
  ), { isMounted: r, ref: l, style: c, getFloatingProps: d } = G(
    (o == null ? void 0 : o.show) || !1,
    (o == null ? void 0 : o.referencePos) || null,
    1e3,
    {
      placement: "left-start",
      ...e.floatingOptions
    }
  );
  if (!r || !o)
    return null;
  const { show: s, referencePos: a, ...u } = o, m = e.sideMenu || pr;
  return /* @__PURE__ */ i("div", { ref: l, style: c, ...d(), children: /* @__PURE__ */ i(m, { ...u, ...n, editor: t }) });
};
async function wr(e, t) {
  return (await on(e, t)).map(
    ({ id: n, onItemClick: o }) => ({
      id: n,
      onItemClick: o,
      icon: n
    })
  );
}
function vr(e) {
  const t = C(), n = M(), { items: o, loadingState: r, selectedIndex: l, onItemClick: c, columns: d } = e, s = r === "loading-initial" || r === "loading" ? /* @__PURE__ */ i(
    t.GridSuggestionMenu.Loader,
    {
      className: "bn-grid-suggestion-menu-loader",
      columns: d,
      children: n.suggestion_menu.loading
    }
  ) : null, a = x(() => {
    const u = [];
    for (let m = 0; m < o.length; m++) {
      const h = o[m];
      u.push(
        /* @__PURE__ */ i(
          t.GridSuggestionMenu.Item,
          {
            className: "bn-grid-suggestion-menu-item",
            item: h,
            id: `bn-grid-suggestion-menu-item-${m}`,
            isSelected: m === l,
            onClick: () => c == null ? void 0 : c(h)
          },
          h.id
        )
      );
    }
    return u;
  }, [t, o, c, l]);
  return /* @__PURE__ */ v(
    t.GridSuggestionMenu.Root,
    {
      id: "bn-grid-suggestion-menu",
      columns: d,
      className: "bn-grid-suggestion-menu",
      children: [
        s,
        a,
        a.length === 0 && e.loadingState === "loaded" && /* @__PURE__ */ i(
          t.GridSuggestionMenu.EmptyItem,
          {
            className: "bn-grid-suggestion-menu-empty-item",
            columns: d,
            children: n.suggestion_menu.no_items_title
          }
        )
      ]
    }
  );
}
function Lt(e, t, n, o = 3) {
  const r = N(0);
  y(() => {
    t !== void 0 && (e.length > 0 ? r.current = t.length : t.length - r.current > o && n());
  }, [n, o, e.length, t]);
}
function Et(e, t) {
  const [n, o] = w([]), [r, l] = w(!1), c = N(), d = N();
  return y(() => {
    const s = e;
    c.current = e, l(!0), t(e).then((a) => {
      c.current === s && (o(a), l(!1), d.current = s);
    });
  }, [e, t]), {
    items: n || [],
    // The query that was used to retrieve the last set of items may not be the
    // same as the current query as the items from the current query may not
    // have been retrieved yet. This is useful when using the returns of this
    // hook in other hooks.
    usedQuery: d.current,
    loadingState: d.current === void 0 ? "loading-initial" : r ? "loading" : "loaded"
  };
}
function Hr(e, t, n, o, r) {
  const [l, c] = w(0), d = o !== void 0 && o > 1;
  return y(() => {
    var a;
    const s = (u) => (u.key === "ArrowLeft" && (u.preventDefault(), n.length && c((l - 1 + n.length) % n.length)), u.key === "ArrowRight" && (u.preventDefault(), n.length && c((l + 1 + n.length) % n.length)), u.key === "ArrowUp" ? (u.preventDefault(), n.length && c(
      (l - o + n.length) % n.length
    ), !0) : u.key === "ArrowDown" ? (u.preventDefault(), n.length && c((l + o) % n.length), !0) : u.key === "Enter" && !u.isComposing ? (u.preventDefault(), n.length && (r == null || r(n[l])), !0) : !1);
    return (a = e.domElement) == null || a.addEventListener(
      "keydown",
      s,
      !0
    ), () => {
      var u;
      (u = e.domElement) == null || u.removeEventListener(
        "keydown",
        s,
        !0
      );
    };
  }, [e.domElement, n, l, r, o, d]), y(() => {
    c(0);
  }, [t]), {
    selectedIndex: n.length === 0 ? void 0 : l
  };
}
function Mr(e) {
  const n = D().setContentEditableProps, o = b(), {
    getItems: r,
    gridSuggestionMenuComponent: l,
    query: c,
    clearQuery: d,
    closeMenu: s,
    onItemClick: a,
    columns: u
  } = e, m = g(
    (B) => {
      s(), d(), a == null || a(B);
    },
    [a, s, d]
  ), { items: h, usedQuery: f, loadingState: H } = Et(
    c,
    r
  );
  Lt(h, f, s);
  const { selectedIndex: p } = Hr(
    o,
    c,
    h,
    u,
    m
  );
  return y(() => (n((B) => ({
    ...B,
    "aria-expanded": !0,
    "aria-controls": "bn-suggestion-menu"
  })), () => {
    n((B) => ({
      ...B,
      "aria-expanded": !1,
      "aria-controls": void 0
    }));
  }), [n]), y(() => (n((B) => ({
    ...B,
    "aria-activedescendant": p ? "bn-suggestion-menu-item-" + p : void 0
  })), () => {
    n((B) => ({
      ...B,
      "aria-activedescendant": void 0
    }));
  }), [n, p]), /* @__PURE__ */ i(
    l,
    {
      items: h,
      onItemClick: m,
      loadingState: H,
      selectedIndex: p,
      columns: u
    }
  );
}
function xr(e) {
  const t = b(), {
    triggerCharacter: n,
    gridSuggestionMenuComponent: o,
    columns: r,
    minQueryLength: l,
    onItemClick: c,
    getItems: d,
    floatingOptions: s
  } = e, a = x(() => c || ((S) => {
    S.onItemClick(t);
  }), [t, c]), u = x(() => d || (async (S) => await wr(
    t,
    S
  )), [t, d]), m = {
    closeMenu: t.suggestionMenus.closeMenu,
    clearQuery: t.suggestionMenus.clearQuery
  }, h = g(
    (S) => t.suggestionMenus.onUpdate(n, S),
    [t.suggestionMenus, n]
  ), f = O(h), { isMounted: H, ref: p, style: V, getFloatingProps: B } = G(
    (f == null ? void 0 : f.show) || !1,
    (f == null ? void 0 : f.referencePos) || null,
    2e3,
    {
      placement: "bottom-start",
      middleware: [
        A(10),
        // Flips the menu placement to maximize the space available, and prevents
        // the menu from being cut off by the confines of the screen.
        W(),
        Se({
          apply({ availableHeight: S, elements: I }) {
            Object.assign(I.floating.style, {
              maxHeight: `${S - 10}px`
            });
          }
        })
      ],
      onOpenChange(S) {
        S || t.suggestionMenus.closeMenu();
      },
      ...s
    }
  );
  return !H || !f || !(f != null && f.ignoreQueryLength) && l && (f.query.startsWith(" ") || f.query.length < l) ? null : /* @__PURE__ */ i("div", { ref: p, style: V, ...B(), children: /* @__PURE__ */ i(
    Mr,
    {
      query: f.query,
      closeMenu: m.closeMenu,
      clearQuery: m.clearQuery,
      getItems: u,
      columns: r,
      gridSuggestionMenuComponent: o || vr,
      onItemClick: a
    }
  ) });
}
function yr(e) {
  const t = C(), n = M(), { items: o, loadingState: r, selectedIndex: l, onItemClick: c } = e, d = r === "loading-initial" || r === "loading" ? /* @__PURE__ */ i(t.SuggestionMenu.Loader, { className: "bn-suggestion-menu-loader", children: n.suggestion_menu.loading }) : null, s = x(() => {
    let a;
    const u = [];
    for (let m = 0; m < o.length; m++) {
      const h = o[m];
      h.group !== a && (a = h.group, u.push(
        /* @__PURE__ */ i(
          t.SuggestionMenu.Label,
          {
            className: "bn-suggestion-menu-label",
            children: a
          },
          a
        )
      )), u.push(
        /* @__PURE__ */ i(
          t.SuggestionMenu.Item,
          {
            className: "bn-suggestion-menu-item",
            item: h,
            id: `bn-suggestion-menu-item-${m}`,
            isSelected: m === l,
            onClick: () => c == null ? void 0 : c(h)
          },
          h.title
        )
      );
    }
    return u;
  }, [t, o, c, l]);
  return /* @__PURE__ */ v(
    t.SuggestionMenu.Root,
    {
      id: "bn-suggestion-menu",
      className: "bn-suggestion-menu",
      children: [
        s,
        s.length === 0 && (e.loadingState === "loading" || e.loadingState === "loaded") && /* @__PURE__ */ i(
          t.SuggestionMenu.EmptyItem,
          {
            className: "bn-suggestion-menu-item",
            children: n.suggestion_menu.no_items_title
          }
        ),
        d
      ]
    }
  );
}
function Br(e, t, n, o) {
  const [r, l] = w(0);
  return y(() => {
    var d;
    const c = (s) => s.key === "ArrowUp" ? (s.preventDefault(), n.length && l((r - 1 + n.length) % n.length), !0) : s.key === "ArrowDown" ? (s.preventDefault(), n.length && l((r + 1) % n.length), !0) : s.key === "Enter" && !s.isComposing ? (s.preventDefault(), s.stopPropagation(), n.length && (o == null || o(n[r])), !0) : !1;
    return (d = e.domElement) == null || d.addEventListener(
      "keydown",
      c,
      !0
    ), () => {
      var s;
      (s = e.domElement) == null || s.removeEventListener(
        "keydown",
        c,
        !0
      );
    };
  }, [e.domElement, n, r, o]), y(() => {
    l(0);
  }, [t]), {
    selectedIndex: n.length === 0 ? void 0 : r
  };
}
function Vr(e) {
  const n = D().setContentEditableProps, o = b(), {
    getItems: r,
    suggestionMenuComponent: l,
    query: c,
    clearQuery: d,
    closeMenu: s,
    onItemClick: a
  } = e, u = g(
    (V) => {
      s(), d(), a == null || a(V);
    },
    [a, s, d]
  ), { items: m, usedQuery: h, loadingState: f } = Et(
    c,
    r
  );
  Lt(m, h, s);
  const { selectedIndex: H } = Br(
    o,
    c,
    m,
    u
  );
  return y(() => (n((V) => ({
    ...V,
    "aria-expanded": !0,
    "aria-controls": "bn-suggestion-menu"
  })), () => {
    n((V) => ({
      ...V,
      "aria-expanded": !1,
      "aria-controls": void 0
    }));
  }), [n]), y(() => (n((V) => ({
    ...V,
    "aria-activedescendant": H ? "bn-suggestion-menu-item-" + H : void 0
  })), () => {
    n((V) => ({
      ...V,
      "aria-activedescendant": void 0
    }));
  }), [n, H]), /* @__PURE__ */ i(
    l,
    {
      items: m,
      onItemClick: u,
      loadingState: f,
      selectedIndex: H
    }
  );
}
const Sr = {
  heading: ft,
  heading_2: gt,
  heading_3: bt,
  quote: vt,
  numbered_list: kt,
  bullet_list: wt,
  check_list: pt,
  paragraph: _e,
  table: mo,
  image: Ht,
  video: fo,
  audio: Mt,
  file: Re,
  emoji: yo,
  code_block: oo
};
function Tr(e) {
  return rn(e).map((t) => {
    const n = Sr[t.key];
    return {
      ...t,
      icon: /* @__PURE__ */ i(n, { size: 18 })
    };
  });
}
function Lr(e) {
  const t = b(), {
    triggerCharacter: n,
    suggestionMenuComponent: o,
    minQueryLength: r,
    onItemClick: l,
    getItems: c,
    floatingOptions: d
  } = e, s = x(() => l || ((B) => {
    B.onItemClick(t);
  }), [t, l]), a = x(() => c || (async (B) => ln(
    Tr(t),
    B
  )), [t, c]), u = {
    closeMenu: t.suggestionMenus.closeMenu,
    clearQuery: t.suggestionMenus.clearQuery
  }, m = g(
    (B) => t.suggestionMenus.onUpdate(n, B),
    [t.suggestionMenus, n]
  ), h = O(m), { isMounted: f, ref: H, style: p, getFloatingProps: V } = G(
    (h == null ? void 0 : h.show) || !1,
    (h == null ? void 0 : h.referencePos) || null,
    2e3,
    {
      placement: "bottom-start",
      middleware: [
        A(10),
        // Flips the menu placement to maximize the space available, and prevents
        // the menu from being cut off by the confines of the screen.
        W({
          mainAxis: !0,
          crossAxis: !1
        }),
        le(),
        Se({
          apply({ availableHeight: B, elements: S }) {
            Object.assign(S.floating.style, {
              maxHeight: `${B - 10}px`
            });
          }
        })
      ],
      onOpenChange(B) {
        B || t.suggestionMenus.closeMenu();
      },
      ...d
    }
  );
  return !f || !h || !(h != null && h.ignoreQueryLength) && r && (h.query.startsWith(" ") || h.query.length < r) ? null : /* @__PURE__ */ i("div", { ref: H, style: p, ...V(), children: /* @__PURE__ */ i(
    Vr,
    {
      query: h.query,
      closeMenu: u.closeMenu,
      clearQuery: u.clearQuery,
      getItems: a,
      suggestionMenuComponent: o || yr,
      onItemClick: s
    }
  ) });
}
const Er = (e, t = 0.3) => {
  const n = Math.floor(e) + t, o = Math.ceil(e) - t;
  return e >= n && e <= o ? Math.round(e) : e < n ? Math.floor(e) : Math.ceil(e);
}, Rr = (e) => {
  const t = C(), n = N(!1), [o, r] = w(), l = g(
    (d) => {
      e.onMouseDown(), r({
        originalContent: e.block.content,
        originalCroppedContent: {
          rows: e.editor.tableHandles.cropEmptyRowsOrColumns(
            e.block,
            e.orientation === "addOrRemoveColumns" ? "columns" : "rows"
          )
        },
        startPos: e.orientation === "addOrRemoveColumns" ? d.clientX : d.clientY
      }), n.current = !1, d.preventDefault();
    },
    [e]
  ), c = g(() => {
    n.current || e.editor.updateBlock(e.block, {
      type: "table",
      content: {
        ...e.block.content,
        rows: e.orientation === "addOrRemoveColumns" ? e.editor.tableHandles.addRowsOrColumns(
          e.block,
          "columns",
          1
        ) : e.editor.tableHandles.addRowsOrColumns(
          e.block,
          "rows",
          1
        )
      }
    });
  }, [e.block, e.orientation, e.editor]);
  return y(() => {
    const d = (s) => {
      var H, p;
      if (!o)
        throw new Error("editingState is undefined");
      n.current = !0;
      const a = (e.orientation === "addOrRemoveColumns" ? s.clientX : s.clientY) - o.startPos, u = e.orientation === "addOrRemoveColumns" ? ((H = o.originalCroppedContent.rows[0]) == null ? void 0 : H.cells.length) ?? 0 : o.originalCroppedContent.rows.length, m = e.orientation === "addOrRemoveColumns" ? ((p = o.originalContent.rows[0]) == null ? void 0 : p.cells.length) ?? 0 : o.originalContent.rows.length, h = e.orientation === "addOrRemoveColumns" ? e.block.content.rows[0].cells.length : e.block.content.rows.length, f = m + Er(
        a / (e.orientation === "addOrRemoveColumns" ? cn : an),
        0.3
      );
      f >= u && f > 0 && f !== h && (e.editor.updateBlock(e.block, {
        type: "table",
        content: {
          ...e.block.content,
          rows: e.orientation === "addOrRemoveColumns" ? e.editor.tableHandles.addRowsOrColumns(
            {
              type: "table",
              content: o.originalCroppedContent
            },
            "columns",
            f - u
          ) : e.editor.tableHandles.addRowsOrColumns(
            {
              type: "table",
              content: o.originalCroppedContent
            },
            "rows",
            f - u
          )
        }
      }), e.block.content && e.editor.setTextCursorPosition(e.block));
    };
    return o && window.addEventListener("mousemove", d), () => {
      window.removeEventListener("mousemove", d);
    };
  }, [o, e.block, e.editor, e.orientation]), y(() => {
    const d = e.onMouseUp, s = () => {
      r(void 0), d();
    };
    return o && window.addEventListener("mouseup", s), () => {
      window.removeEventListener("mouseup", s);
    };
  }, [o, e.onMouseUp]), /* @__PURE__ */ i(
    t.TableHandle.ExtendButton,
    {
      className: R(
        "bn-extend-button",
        e.orientation === "addOrRemoveColumns" ? "bn-extend-button-add-remove-columns" : "bn-extend-button-add-remove-rows",
        o !== null ? "bn-extend-button-editing" : ""
      ),
      onClick: c,
      onMouseDown: l,
      children: e.children || /* @__PURE__ */ i(po, { size: 18, "data-test": "extendButton" })
    }
  );
}, Je = (e) => {
  const t = C(), n = M(), r = b().tableHandles;
  return r ? /* @__PURE__ */ i(
    t.Generic.Menu.Item,
    {
      onClick: () => {
        r.addRowOrColumn(
          e.index,
          e.orientation === "row" ? { orientation: "row", side: e.side } : { orientation: "column", side: e.side }
        );
      },
      children: n.table_handle[`add_${e.side}_menuitem`]
    }
  ) : null;
}, _r = (e) => {
  const t = C(), n = M(), r = b().tableHandles;
  return r ? /* @__PURE__ */ i(
    t.Generic.Menu.Item,
    {
      onClick: () => {
        r.removeRowOrColumn(e.index, e.orientation);
      },
      children: e.orientation === "row" ? n.table_handle.delete_row_menuitem : n.table_handle.delete_column_menuitem
    }
  ) : null;
}, Ir = (e) => {
  const t = C(), n = M(), o = b(), r = o.tableHandles, l = x(() => !r || !e.block ? [] : e.orientation === "row" ? r.getCellsAtRowHandle(e.block, e.index) : r.getCellsAtColumnHandle(e.block, e.index), [e.block, e.index, e.orientation, r]), c = (s, a) => {
    const u = e.block.content.rows.map((m) => ({
      ...m,
      cells: m.cells.map((h) => K(h))
    }));
    l.forEach(({ row: m, col: h }) => {
      a === "text" ? u[m].cells[h].props.textColor = s : u[m].cells[h].props.backgroundColor = s;
    }), o.updateBlock(e.block, {
      type: "table",
      content: {
        ...e.block.content,
        rows: u
      }
    }), o.setTextCursorPosition(e.block);
  };
  if (!l || !l[0] || !r || o.settings.tables.cellTextColor === !1 && o.settings.tables.cellBackgroundColor === !1)
    return null;
  const d = K(l[0].cell);
  return /* @__PURE__ */ v(t.Generic.Menu.Root, { position: "right", sub: !0, children: [
    /* @__PURE__ */ i(t.Generic.Menu.Trigger, { sub: !0, children: /* @__PURE__ */ i(
      t.Generic.Menu.Item,
      {
        className: "bn-menu-item",
        subTrigger: !0,
        children: e.children || n.drag_handle.colors_menuitem
      }
    ) }),
    /* @__PURE__ */ i(
      t.Generic.Menu.Dropdown,
      {
        sub: !0,
        className: "bn-menu-dropdown bn-color-picker-dropdown",
        children: /* @__PURE__ */ i(
          me,
          {
            iconSize: 18,
            text: o.settings.tables.cellTextColor ? {
              // All cells have the same text color
              color: l.every(
                ({ cell: s }) => X(s) && s.props.textColor === d.props.textColor
              ) ? d.props.textColor : "default",
              setColor: (s) => {
                c(s, "text");
              }
            } : void 0,
            background: o.settings.tables.cellBackgroundColor ? {
              color: l.every(
                ({ cell: s }) => X(s) && s.props.backgroundColor === d.props.backgroundColor
              ) ? d.props.backgroundColor : "default",
              setColor: (s) => c(s, "background")
            } : void 0
          }
        )
      }
    )
  ] });
}, Nr = (e) => {
  const t = C(), n = M(), o = b();
  if (!o.tableHandles || e.index !== 0 || e.orientation !== "row" || !o.settings.tables.headers)
    return null;
  const l = !!e.block.content.headerRows;
  return /* @__PURE__ */ i(
    t.Generic.Menu.Item,
    {
      className: "bn-menu-item",
      checked: l,
      onClick: () => {
        const c = o.getBlock(e.block.id);
        c && o.updateBlock(c, {
          ...c,
          content: {
            ...c.content,
            headerRows: l ? void 0 : 1
          }
        });
      },
      children: n.drag_handle.header_row_menuitem
    }
  );
}, Pr = (e) => {
  const t = C(), n = M(), o = b();
  if (!o.tableHandles || e.index !== 0 || e.orientation !== "column" || !o.settings.tables.headers)
    return null;
  const l = !!e.block.content.headerCols;
  return /* @__PURE__ */ i(
    t.Generic.Menu.Item,
    {
      className: "bn-menu-item",
      checked: l,
      onClick: () => {
        const c = o.getBlock(e.block.id);
        c && o.updateBlock(c, {
          ...c,
          content: {
            ...c.content,
            headerCols: l ? void 0 : 1
          }
        });
      },
      children: n.drag_handle.header_column_menuitem
    }
  );
}, Or = (e) => {
  const t = C();
  return /* @__PURE__ */ i(t.Generic.Menu.Dropdown, { className: "bn-table-handle-menu", children: e.children || /* @__PURE__ */ v(T, { children: [
    /* @__PURE__ */ i(
      _r,
      {
        orientation: e.orientation,
        block: e.block,
        index: e.index
      }
    ),
    /* @__PURE__ */ i(
      Je,
      {
        orientation: e.orientation,
        block: e.block,
        index: e.index,
        side: e.orientation === "row" ? "above" : "left"
      }
    ),
    /* @__PURE__ */ i(
      Je,
      {
        orientation: e.orientation,
        block: e.block,
        index: e.index,
        side: e.orientation === "row" ? "below" : "right"
      }
    ),
    /* @__PURE__ */ i(
      Nr,
      {
        orientation: e.orientation,
        block: e.block,
        index: e.index
      }
    ),
    /* @__PURE__ */ i(
      Pr,
      {
        orientation: e.orientation,
        block: e.block,
        index: e.index
      }
    ),
    /* @__PURE__ */ i(
      Ir,
      {
        orientation: e.orientation,
        block: e.block,
        index: e.index
      }
    )
  ] }) });
}, Dr = (e) => {
  const t = C(), [n, o] = w(!1), r = e.tableHandleMenu || Or, l = x(() => {
    const c = e.editor.tableHandles;
    return !c || !e.block ? !1 : e.orientation === "column" ? c.getCellsAtColumnHandle(e.block, e.index).every(({ cell: d }) => nt(d) === 1) : c.getCellsAtRowHandle(e.block, e.index).every(({ cell: d }) => ot(d) === 1);
  }, [e.block, e.editor.tableHandles, e.index, e.orientation]);
  return /* @__PURE__ */ v(
    t.Generic.Menu.Root,
    {
      onOpenChange: (c) => {
        c ? (e.freezeHandles(), e.hideOtherSide()) : (e.unfreezeHandles(), e.showOtherSide(), e.editor.focus());
      },
      position: "right",
      children: [
        /* @__PURE__ */ i(t.Generic.Menu.Trigger, { children: /* @__PURE__ */ i(
          t.TableHandle.Root,
          {
            className: R(
              "bn-table-handle",
              n ? "bn-table-handle-dragging" : "",
              l ? "" : "bn-table-handle-not-draggable"
            ),
            draggable: l,
            onDragStart: (c) => {
              o(!0), e.dragStart(c);
            },
            onDragEnd: () => {
              e.dragEnd(), o(!1);
            },
            style: e.orientation === "column" ? { transform: "rotate(0.25turn)" } : void 0,
            children: e.children || /* @__PURE__ */ i(Tt, { size: 24, "data-test": "tableHandle" })
          }
        ) }),
        ae(
          /* @__PURE__ */ i(
            r,
            {
              orientation: e.orientation,
              block: e.block,
              index: e.index
            }
          ),
          e.menuContainer
        )
      ]
    }
  );
};
function Qe(e, t, n) {
  const { refs: o, update: r, context: l, floatingStyles: c } = Be({
    open: t,
    placement: e === "addOrRemoveColumns" ? "right" : "bottom",
    middleware: [
      Se({
        apply({ rects: a, elements: u }) {
          Object.assign(
            u.floating.style,
            e === "addOrRemoveColumns" ? {
              height: `${a.reference.height}px`
            } : {
              width: `${a.reference.width}px`
            }
          );
        }
      })
    ]
  }), { isMounted: d, styles: s } = Ve(l);
  return y(() => {
    r();
  }, [n, r]), y(() => {
    n !== null && o.setReference({
      getBoundingClientRect: () => n
    });
  }, [e, n, o]), x(
    () => ({
      isMounted: d,
      ref: o.setFloating,
      style: {
        display: "flex",
        ...s,
        ...c
      }
    }),
    [c, d, o.setFloating, s]
  );
}
function Zr(e, t, n) {
  const o = Qe(
    "addOrRemoveRows",
    t,
    n
  ), r = Qe(
    "addOrRemoveColumns",
    e,
    n
  );
  return x(
    () => ({
      addOrRemoveRowsButton: o,
      addOrRemoveColumnsButton: r
    }),
    [r, o]
  );
}
function Fr(e, t, n) {
  return n && n.draggedCellOrientation === "row" ? new DOMRect(
    t.x,
    n.mousePos,
    t.width,
    0
  ) : new DOMRect(
    t.x,
    e.y,
    t.width,
    e.height
  );
}
function Ar(e, t, n) {
  return n && n.draggedCellOrientation === "col" ? new DOMRect(
    n.mousePos,
    t.y,
    0,
    t.height
  ) : new DOMRect(
    e.x,
    t.y,
    e.width,
    t.height
  );
}
function Gr(e) {
  return new DOMRect(
    e.x,
    e.y,
    e.width,
    0
  );
}
function Ce(e, t, n, o, r) {
  const { refs: l, update: c, context: d, floatingStyles: s } = Be({
    open: t,
    placement: e === "row" ? "left" : e === "col" ? "top" : "bottom-end",
    middleware: [
      A(
        e === "row" ? -10 : e === "col" ? -12 : { mainAxis: 1, crossAxis: -1 }
      )
    ]
  }), { isMounted: a, styles: u } = Ve(d);
  return y(() => {
    c();
  }, [n, o, c]), y(() => {
    n === null || o === null || // Ignore cell handle when dragging
    r && e === "cell" || l.setReference({
      getBoundingClientRect: () => (e === "row" ? Fr : e === "col" ? Ar : Gr)(n, o, r)
    });
  }, [r, e, n, o, l]), x(
    () => ({
      isMounted: a,
      ref: l.setFloating,
      style: {
        display: "flex",
        ...u,
        ...s
      }
    }),
    [s, a, l.setFloating, u]
  );
}
function Ur(e, t, n, o) {
  const r = Ce(
    "row",
    e,
    t,
    n,
    o
  ), l = Ce(
    "col",
    e,
    t,
    n,
    o
  ), c = Ce(
    "cell",
    e,
    t,
    n,
    o
  );
  return x(
    () => ({
      rowHandle: r,
      colHandle: l,
      cellHandle: c
    }),
    [l, r, c]
  );
}
const zr = (e) => {
  var c, d;
  const t = C(), n = M(), o = b(), r = (s, a) => {
    const u = e.block.content.rows.map((m) => ({
      ...m,
      cells: m.cells.map((h) => K(h))
    }));
    a === "text" ? u[e.rowIndex].cells[e.colIndex].props.textColor = s : u[e.rowIndex].cells[e.colIndex].props.backgroundColor = s, o.updateBlock(e.block, {
      type: "table",
      content: {
        ...e.block.content,
        rows: u
      }
    }), o.setTextCursorPosition(e.block);
  }, l = (d = (c = e.block.content.rows[e.rowIndex]) == null ? void 0 : c.cells) == null ? void 0 : d[e.colIndex];
  return !l || o.settings.tables.cellTextColor === !1 && o.settings.tables.cellBackgroundColor === !1 ? null : /* @__PURE__ */ v(t.Generic.Menu.Root, { position: "right", sub: !0, children: [
    /* @__PURE__ */ i(t.Generic.Menu.Trigger, { sub: !0, children: /* @__PURE__ */ i(
      t.Generic.Menu.Item,
      {
        className: "bn-menu-item",
        subTrigger: !0,
        children: e.children || n.drag_handle.colors_menuitem
      }
    ) }),
    /* @__PURE__ */ i(
      t.Generic.Menu.Dropdown,
      {
        sub: !0,
        className: "bn-menu-dropdown bn-color-picker-dropdown",
        children: /* @__PURE__ */ i(
          me,
          {
            iconSize: 18,
            text: o.settings.tables.cellTextColor ? {
              color: X(l) ? l.props.textColor : "default",
              setColor: (s) => r(s, "text")
            } : void 0,
            background: o.settings.tables.cellBackgroundColor ? {
              color: X(l) ? l.props.backgroundColor : "default",
              setColor: (s) => r(s, "background")
            } : void 0
          }
        )
      }
    )
  ] });
}, jr = (e) => {
  var l, c;
  const t = C(), n = M(), o = b(), r = (c = (l = e.block.content.rows[e.rowIndex]) == null ? void 0 : l.cells) == null ? void 0 : c[e.colIndex];
  return !r || !X(r) || ot(r) === 1 && nt(r) === 1 || !o.settings.tables.splitCells ? null : /* @__PURE__ */ i(
    t.Generic.Menu.Item,
    {
      onClick: () => {
        var d;
        (d = o.tableHandles) == null || d.splitCell({
          row: e.rowIndex,
          col: e.colIndex
        });
      },
      children: n.table_handle.split_cell_menuitem
    }
  );
}, Wr = (e) => {
  const t = C();
  return /* @__PURE__ */ i(
    t.Generic.Menu.Dropdown,
    {
      className: "bn-menu-dropdown bn-drag-handle-menu",
      children: e.children || /* @__PURE__ */ v(T, { children: [
        /* @__PURE__ */ i(
          jr,
          {
            block: e.block,
            rowIndex: e.rowIndex,
            colIndex: e.colIndex
          }
        ),
        /* @__PURE__ */ i(
          zr,
          {
            block: e.block,
            rowIndex: e.rowIndex,
            colIndex: e.colIndex
          }
        )
      ] })
    }
  );
}, $r = (e) => {
  const t = C(), n = e.tableCellMenu || Wr;
  return !e.editor.settings.tables.splitCells && !e.editor.settings.tables.cellBackgroundColor && !e.editor.settings.tables.cellTextColor ? null : /* @__PURE__ */ v(
    t.Generic.Menu.Root,
    {
      onOpenChange: (o) => {
        o ? e.freezeHandles() : (e.unfreezeHandles(), e.editor.focus());
      },
      position: "right",
      children: [
        /* @__PURE__ */ i(t.Generic.Menu.Trigger, { children: /* @__PURE__ */ i(t.Generic.Menu.Button, { className: "bn-table-cell-handle", children: e.children || /* @__PURE__ */ i(ur, { size: 12, "data-test": "tableCellHandle" }) }) }),
        ae(
          /* @__PURE__ */ i(
            n,
            {
              block: e.block,
              rowIndex: e.rowIndex,
              colIndex: e.colIndex
            }
          ),
          e.menuContainer
        )
      ]
    }
  );
}, qr = (e) => {
  var $, E;
  const t = b(), [n, o] = w(null);
  if (!t.tableHandles)
    throw new Error(
      "TableHandlesController can only be used when BlockNote editor schema contains table block"
    );
  const r = {
    rowDragStart: t.tableHandles.rowDragStart,
    colDragStart: t.tableHandles.colDragStart,
    dragEnd: t.tableHandles.dragEnd,
    freezeHandles: t.tableHandles.freezeHandles,
    unfreezeHandles: t.tableHandles.unfreezeHandles
  }, { freezeHandles: l, unfreezeHandles: c } = r, d = g(() => {
    l(), I(!0), B(!0);
  }, [l]), s = g(() => {
    c(), I(!1), B(!1);
  }, [c]), a = O(
    t.tableHandles.onUpdate.bind(t.tableHandles)
  ), u = x(() => {
    var F, ee;
    return a != null && a.draggingState ? {
      draggedCellOrientation: (F = a == null ? void 0 : a.draggingState) == null ? void 0 : F.draggedCellOrientation,
      mousePos: (ee = a == null ? void 0 : a.draggingState) == null ? void 0 : ee.mousePos
    } : void 0;
  }, [
    a == null ? void 0 : a.draggingState,
    ($ = a == null ? void 0 : a.draggingState) == null ? void 0 : $.draggedCellOrientation,
    (E = a == null ? void 0 : a.draggingState) == null ? void 0 : E.mousePos
  ]), { rowHandle: m, colHandle: h, cellHandle: f } = Ur(
    (a == null ? void 0 : a.show) || !1,
    (a == null ? void 0 : a.referencePosCell) || null,
    (a == null ? void 0 : a.referencePosTable) || null,
    u
  ), { addOrRemoveColumnsButton: H, addOrRemoveRowsButton: p } = Zr(
    (a == null ? void 0 : a.showAddOrRemoveColumnsButton) || !1,
    (a == null ? void 0 : a.showAddOrRemoveRowsButton) || !1,
    (a == null ? void 0 : a.referencePosTable) || null
  ), [V, B] = w(!1), [S, I] = w(!1);
  if (!a)
    return null;
  const z = e.tableHandle || Dr, j = e.extendButton || Rr, Z = e.tableCellHandle || $r;
  return /* @__PURE__ */ v(T, { children: [
    /* @__PURE__ */ i("div", { ref: o }),
    /* @__PURE__ */ v($t, { root: a.widgetContainer, children: [
      !V && n && m.isMounted && a.rowIndex !== void 0 && /* @__PURE__ */ i("div", { ref: m.ref, style: m.style, children: /* @__PURE__ */ i(
        z,
        {
          editor: t,
          orientation: "row",
          showOtherSide: () => I(!1),
          hideOtherSide: () => I(!0),
          index: a.rowIndex,
          block: a.block,
          dragStart: r.rowDragStart,
          dragEnd: r.dragEnd,
          freezeHandles: r.freezeHandles,
          unfreezeHandles: r.unfreezeHandles,
          menuContainer: n
        }
      ) }),
      !S && n && h.isMounted && a.colIndex !== void 0 && /* @__PURE__ */ i("div", { ref: h.ref, style: h.style, children: /* @__PURE__ */ i(
        z,
        {
          editor: t,
          orientation: "column",
          showOtherSide: () => B(!1),
          hideOtherSide: () => B(!0),
          index: a.colIndex,
          block: a.block,
          dragStart: r.colDragStart,
          dragEnd: r.dragEnd,
          freezeHandles: r.freezeHandles,
          unfreezeHandles: r.unfreezeHandles,
          menuContainer: n
        }
      ) }),
      n && f.isMounted && a.colIndex !== void 0 && a.rowIndex !== void 0 && /* @__PURE__ */ i("div", { ref: f.ref, style: f.style, children: /* @__PURE__ */ i(
        Z,
        {
          editor: t,
          block: a.block,
          rowIndex: a.rowIndex,
          colIndex: a.colIndex,
          menuContainer: n,
          freezeHandles: r.freezeHandles,
          unfreezeHandles: r.unfreezeHandles
        }
      ) }),
      /* @__PURE__ */ i(
        "div",
        {
          ref: p.ref,
          style: p.style,
          children: /* @__PURE__ */ i(
            j,
            {
              editor: t,
              orientation: "addOrRemoveRows",
              block: a.block,
              onMouseDown: d,
              onMouseUp: s
            }
          )
        }
      ),
      /* @__PURE__ */ i(
        "div",
        {
          ref: H.ref,
          style: H.style,
          children: /* @__PURE__ */ i(
            j,
            {
              editor: t,
              orientation: "addOrRemoveColumns",
              block: a.block,
              onMouseDown: d,
              onMouseUp: s
            }
          )
        }
      )
    ] })
  ] });
};
function Kr(e) {
  const t = b();
  if (!t)
    throw new Error(
      "BlockNoteDefaultUI must be used within a BlockNoteContext.Provider"
    );
  return /* @__PURE__ */ v(T, { children: [
    e.formattingToolbar !== !1 && /* @__PURE__ */ i(or, {}),
    e.linkToolbar !== !1 && /* @__PURE__ */ i(ar, {}),
    e.slashMenu !== !1 && /* @__PURE__ */ i(Lr, { triggerCharacter: "/" }),
    e.emojiPicker !== !1 && /* @__PURE__ */ i(
      xr,
      {
        triggerCharacter: ":",
        columns: 10,
        minQueryLength: 2
      }
    ),
    e.sideMenu !== !1 && /* @__PURE__ */ i(kr, {}),
    t.filePanel && e.filePanel !== !1 && /* @__PURE__ */ i(No, {}),
    t.tableHandles && e.tableHandles !== !1 && /* @__PURE__ */ i(qr, {}),
    t.comments && e.comments !== !1 && /* @__PURE__ */ v(T, { children: [
      /* @__PURE__ */ i(An, {}),
      /* @__PURE__ */ i(Ro, {})
    ] })
  ] });
}
const Xr = () => {
  const e = x(
    () => {
      var c;
      return (c = window.matchMedia) == null ? void 0 : c.call(window, "(prefers-color-scheme: dark)");
    },
    []
  ), t = x(
    () => {
      var c;
      return (c = window.matchMedia) == null ? void 0 : c.call(window, "(prefers-color-scheme: light)");
    },
    []
  ), n = e == null ? void 0 : e.matches, o = t == null ? void 0 : t.matches, [r, l] = w(n ? "dark" : o ? "light" : "no-preference");
  return y(() => {
    l(n ? "dark" : o ? "light" : "no-preference");
  }, [n, o]), y(() => {
    if (typeof (e == null ? void 0 : e.addEventListener) == "function") {
      const c = ({ matches: s }) => s && l("dark"), d = ({ matches: s }) => s && l("light");
      return e == null || e.addEventListener("change", c), t == null || t.addEventListener("change", d), () => {
        e == null || e.removeEventListener("change", c), t == null || t.removeEventListener("change", d);
      };
    } else {
      const c = () => l(
        e.matches ? "dark" : t.matches ? "light" : "no-preference"
      );
      return e == null || e.addEventListener("change", c), t == null || t.addEventListener("change", c), () => {
        e == null || e.removeEventListener("change", c), t == null || t.removeEventListener("change", c);
      };
    }
  }, [e, t]), typeof window.matchMedia != "function", r;
}, Rt = Me(void 0);
function Yr() {
  return xe(Rt);
}
function Jr() {
  const e = /* @__PURE__ */ new Set();
  let t = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(n) {
      return e.add(n), () => {
        e.delete(n);
      };
    },
    getSnapshot() {
      return t;
    },
    getServerSnapshot() {
      return t;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(n, o) {
      t = {
        ...t,
        [n]: ae(o.reactElement, o.element, n)
      }, e.forEach((r) => r());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(n) {
      const o = { ...t };
      delete o[n], t = o, e.forEach((r) => r());
    }
  };
}
const Qr = ({
  contentComponent: e
}) => {
  const t = ye(
    e.subscribe,
    e.getSnapshot,
    e.getServerSnapshot
  );
  return /* @__PURE__ */ i(T, { children: Object.values(t) });
}, ei = Ut((e, t) => {
  const [n, o] = w();
  return zt(
    t,
    () => (r, l) => {
      lt(() => {
        o({ node: r, container: l });
      }), o(void 0);
    },
    []
  ), /* @__PURE__ */ i(T, { children: n && ae(n.node, n.container) });
}), et = () => {
};
function ti(e, t) {
  const {
    editor: n,
    className: o,
    theme: r,
    children: l,
    editable: c,
    onSelectionChange: d,
    onChange: s,
    formattingToolbar: a,
    linkToolbar: u,
    slashMenu: m,
    emojiPicker: h,
    sideMenu: f,
    filePanel: H,
    tableHandles: p,
    comments: V,
    autoFocus: B,
    renderEditor: S = !n.headless,
    ...I
  } = e, [z, j] = w(), Z = D(), $ = Xr(), E = (Z == null ? void 0 : Z.colorSchemePreference) || $, F = r || (E === "dark" ? "dark" : "light");
  ue(s || et, n), se(d || et, n), y(() => {
    n.isEditable = c !== !1;
  }, [c, n]);
  const ee = g(
    (Dt) => {
      n.elementRenderer = Dt;
    },
    [n]
  ), Nt = x(() => ({
    ...Z,
    editor: n,
    setContentEditableProps: j
  }), [Z, n]), Pt = {
    formattingToolbar: a,
    linkToolbar: u,
    slashMenu: m,
    emojiPicker: h,
    sideMenu: f,
    filePanel: H,
    tableHandles: p,
    comments: V
  }, Ot = {
    autoFocus: B,
    contentEditableProps: z
  };
  return /* @__PURE__ */ i(dt.Provider, { value: Nt, children: /* @__PURE__ */ v(
    Rt.Provider,
    {
      value: {
        editorProps: Ot,
        defaultUIProps: Pt
      },
      children: [
        /* @__PURE__ */ i(ei, { ref: ee }),
        /* @__PURE__ */ i(
          ni,
          {
            className: o,
            renderEditor: S,
            editorColorScheme: F,
            ref: t,
            ...I,
            children: l
          }
        )
      ]
    }
  ) });
}
const ni = P.forwardRef(({ className: e, renderEditor: t, editorColorScheme: n, children: o, ...r }, l) => /* @__PURE__ */ i(
  "div",
  {
    className: R("bn-container", n, e),
    "data-color-scheme": n,
    ...r,
    ref: l,
    children: t ? /* @__PURE__ */ i(oi, { children: o }) : o
  }
)), Fi = P.forwardRef(ti), oi = (e) => {
  const t = Yr(), n = b(), o = x(() => Jr(), []), r = g(
    (l) => {
      n.mount(l, o);
    },
    [n, o]
  );
  return /* @__PURE__ */ v(T, { children: [
    /* @__PURE__ */ i(Qr, { contentComponent: o }),
    /* @__PURE__ */ i(ri, { ...t.editorProps, ...e, mount: r }),
    /* @__PURE__ */ i(Kr, { ...t.defaultUIProps }),
    e.children
  ] });
}, ri = (e) => {
  const { autoFocus: t, mount: n, contentEditableProps: o } = e;
  return /* @__PURE__ */ i(
    "div",
    {
      "aria-autocomplete": "list",
      "aria-haspopup": "listbox",
      "data-bn-autofocus": t,
      ref: n,
      ...o
    }
  );
};
function ie(e, t) {
  let n;
  const o = document.createElement("div");
  let r;
  if (t != null && t.elementRenderer)
    t.elementRenderer(
      e((s) => n = s || void 0),
      o
    );
  else {
    if (!(t != null && t.headless))
      throw new Error(
        "elementRenderer not available, expected headless editor"
      );
    r = Nn(o), lt(() => {
      r.render(e((s) => n = s || void 0));
    });
  }
  if (!o.childElementCount)
    return console.warn("ReactInlineContentSpec: renderHTML() failed"), {
      dom: document.createElement("span")
    };
  n == null || n.setAttribute("data-tmp-find", "true");
  const l = o.cloneNode(!0), c = l.firstElementChild, d = l.querySelector(
    "[data-tmp-find]"
  );
  return d == null || d.removeAttribute("data-tmp-find"), r == null || r.unmount(), {
    dom: c,
    contentDOM: d || void 0
  };
}
function pe(e) {
  var t;
  return (
    // Creates `blockContent` element
    /* @__PURE__ */ i(
      st,
      {
        onDragOver: (n) => n.preventDefault(),
        ...Object.fromEntries(
          Object.entries(e.domAttributes || {}).filter(
            ([n]) => n !== "class"
          )
        ),
        className: R(
          "bn-block-content",
          ((t = e.domAttributes) == null ? void 0 : t.class) || ""
        ),
        "data-content-type": e.blockType,
        ...Object.fromEntries(
          Object.entries(e.blockProps).filter(([n, o]) => {
            const r = e.propSchema[n];
            return !fn.includes(n) && o !== r.default;
          }).map(([n, o]) => [it(n), o])
        ),
        "data-file-block": e.isFileBlock === !0 || void 0,
        children: e.children
      }
    )
  );
}
function he(e, t) {
  const n = Te({
    name: e.type,
    content: e.content === "inline" ? "inline*" : "",
    group: "blockContent",
    selectable: e.isSelectable ?? !0,
    isolating: !0,
    addAttributes() {
      return rt(e.propSchema);
    },
    parseHTML() {
      return mn(e, t.parse);
    },
    renderHTML({ HTMLAttributes: o }) {
      const r = document.createElement("div");
      return un(
        {
          dom: r,
          contentDOM: e.content === "inline" ? r : void 0
        },
        e.type,
        {},
        e.propSchema,
        e.isFileBlock,
        o
      );
    },
    addNodeView() {
      return (o) => {
        const r = ct(
          (l) => {
            var m;
            const c = this.options.editor, d = sn(
              l.getPos,
              c,
              this.editor,
              e.type
            ), s = ((m = this.options.domAttributes) == null ? void 0 : m.blockContent) || {}, a = at().nodeViewContentRef;
            if (!a)
              throw new Error("nodeViewContentRef is not set");
            const u = t.render;
            return /* @__PURE__ */ i(
              pe,
              {
                blockType: d.type,
                blockProps: d.props,
                propSchema: e.propSchema,
                isFileBlock: e.isFileBlock,
                domAttributes: s,
                children: /* @__PURE__ */ i(
                  u,
                  {
                    block: d,
                    editor: c,
                    contentRef: (h) => {
                      a(h), h && (h.className = R(
                        "bn-inline-content",
                        h.className
                      ));
                    }
                  }
                )
              }
            );
          },
          {
            className: "bn-react-node-view-renderer"
          }
        )(o);
        return e.isSelectable === !1 && dn(r, this.editor), r;
      };
    }
  });
  return hn(e, {
    node: n,
    toInternalHTML: (o, r) => {
      var s;
      const l = ((s = n.options.domAttributes) == null ? void 0 : s.blockContent) || {}, c = t.render;
      return ie(
        (a) => /* @__PURE__ */ i(
          pe,
          {
            blockType: o.type,
            blockProps: o.props,
            propSchema: e.propSchema,
            domAttributes: l,
            children: /* @__PURE__ */ i(
              c,
              {
                block: o,
                editor: r,
                contentRef: (u) => {
                  a(u), u && (u.className = R(
                    "bn-inline-content",
                    u.className
                  ));
                }
              }
            )
          }
        ),
        r
      );
    },
    toExternalHTML: (o, r) => {
      var s;
      const l = ((s = n.options.domAttributes) == null ? void 0 : s.blockContent) || {}, c = t.toExternalHTML || t.render;
      return ie((a) => /* @__PURE__ */ i(
        pe,
        {
          blockType: o.type,
          blockProps: o.props,
          propSchema: e.propSchema,
          domAttributes: l,
          children: /* @__PURE__ */ i(
            c,
            {
              block: o,
              editor: r,
              contentRef: (u) => {
                a(u), u && (u.className = R(
                  "bn-inline-content",
                  u.className
                ));
              }
            }
          )
        }
      ), r);
    }
  });
}
function Ne(e) {
  const t = b(), [n, o] = w("loading"), [r, l] = w();
  if (y(() => {
    let c = !0;
    return (async () => {
      let d = "";
      o("loading");
      try {
        d = t.resolveFileUrl ? await t.resolveFileUrl(e) : e;
      } catch {
        o("error");
        return;
      }
      c && (o("loaded"), l(d));
    })(), () => {
      c = !1;
    };
  }, [t, e]), n !== "loaded")
    return {
      loadingState: n
    };
  if (!r)
    throw new Error("Finished fetching file but did not get download URL.");
  return {
    loadingState: n,
    downloadUrl: r
  };
}
const Pe = (e) => /* @__PURE__ */ v("figure", { children: [
  e.children,
  /* @__PURE__ */ i("figcaption", { children: e.caption })
] });
function ii(e) {
  const t = b();
  y(() => t.onUploadEnd(e), [e, t]);
}
function li(e) {
  const t = b();
  y(() => t.onUploadStart(e), [e, t]);
}
function _t(e) {
  const [t, n] = w(!1);
  return li((o) => {
    o === e && n(!0);
  }), ii((o) => {
    o === e && n(!1);
  }), t;
}
const ci = (e) => {
  const t = M(), n = g(
    (r) => {
      r.preventDefault();
    },
    []
  ), o = g(() => {
    e.editor.transact(
      (r) => r.setMeta(e.editor.filePanel.plugin, {
        block: e.block
      })
    );
  }, [e.block, e.editor]);
  return /* @__PURE__ */ v(
    "div",
    {
      className: "bn-add-file-button",
      onMouseDown: n,
      onClick: o,
      children: [
        /* @__PURE__ */ i("div", { className: "bn-add-file-button-icon", children: e.buttonIcon || /* @__PURE__ */ i(Re, { size: 24 }) }),
        /* @__PURE__ */ i("div", { className: "bn-add-file-button-text", children: e.buttonText || t.file_blocks.file.add_button_text })
      ]
    }
  );
}, ai = (e) => /* @__PURE__ */ v(
  "div",
  {
    className: "bn-file-name-with-icon",
    contentEditable: !1,
    draggable: !1,
    children: [
      /* @__PURE__ */ i("div", { className: "bn-file-icon", children: /* @__PURE__ */ i(Re, { size: 24 }) }),
      /* @__PURE__ */ i("p", { className: "bn-file-name", children: e.block.props.name })
    ]
  }
), Oe = (e) => {
  const t = _t(e.block.id);
  return /* @__PURE__ */ i(
    "div",
    {
      className: "bn-file-block-content-wrapper",
      onMouseEnter: e.onMouseEnter,
      onMouseLeave: e.onMouseLeave,
      style: e.style,
      children: t ? (
        // Show loader while a file is being uploaded.
        /* @__PURE__ */ i("div", { className: "bn-file-loading-preview", children: "Loading..." })
      ) : e.block.props.url === "" ? (
        // Show the add file button if the file has not been uploaded yet.
        /* @__PURE__ */ i(ci, { ...e })
      ) : (
        // Show the file preview, or the file name and icon.
        /* @__PURE__ */ v(T, { children: [
          e.block.props.showPreview === !1 || !e.children ? (
            // Show file name and icon.
            /* @__PURE__ */ i(ai, { ...e })
          ) : (
            // Show preview.
            e.children
          ),
          e.block.props.caption && // Show the caption if there is one.
          /* @__PURE__ */ i("p", { className: "bn-file-caption", children: e.block.props.caption })
        ] })
      )
    }
  );
}, fe = (e) => /* @__PURE__ */ v("div", { children: [
  e.children,
  /* @__PURE__ */ i("p", { children: e.caption })
] }), si = (e) => {
  const t = Ne(e.block.props.url);
  return /* @__PURE__ */ i(
    "audio",
    {
      className: "bn-audio",
      src: t.loadingState === "loading" ? e.block.props.url : t.downloadUrl,
      controls: !0,
      contentEditable: !1,
      draggable: !1
    }
  );
}, di = (e) => {
  if (!e.block.props.url)
    return /* @__PURE__ */ i("p", { children: "Add audio" });
  const t = e.block.props.showPreview ? /* @__PURE__ */ i("audio", { src: e.block.props.url }) : /* @__PURE__ */ i("a", { href: e.block.props.url, children: e.block.props.name || e.block.props.url });
  return e.block.props.caption ? e.block.props.showPreview ? /* @__PURE__ */ i(Pe, { caption: e.block.props.caption, children: t }) : /* @__PURE__ */ i(fe, { caption: e.block.props.caption, children: t }) : t;
}, ui = (e) => /* @__PURE__ */ i(
  Oe,
  {
    ...e,
    buttonText: e.editor.dictionary.file_blocks.audio.add_button_text,
    buttonIcon: /* @__PURE__ */ i(Mt, { size: 24 }),
    children: /* @__PURE__ */ i(si, { ...e })
  }
), Ai = he(bn, {
  render: ui,
  parse: gn,
  toExternalHTML: di
}), mi = (e) => {
  if (!e.block.props.url)
    return /* @__PURE__ */ i("p", { children: "Add file" });
  const t = /* @__PURE__ */ i("a", { href: e.block.props.url, children: e.block.props.name || e.block.props.url });
  return e.block.props.caption ? /* @__PURE__ */ i(fe, { caption: e.block.props.caption, children: t }) : t;
}, hi = (e) => /* @__PURE__ */ i(Oe, { ...e }), Gi = he(pn, {
  render: hi,
  parse: Cn,
  toExternalHTML: mi
}), It = (e) => {
  const [t, n] = w(void 0), [o, r] = w(
    e.block.props.previewWidth
  ), [l, c] = w(!1), d = N(null);
  y(() => {
    const f = (p) => {
      var S, I;
      let V;
      e.block.props.textAlignment === "center" ? t.handleUsed === "left" ? V = t.initialWidth + (t.initialClientX - p.clientX) * 2 : V = t.initialWidth + (p.clientX - t.initialClientX) * 2 : t.handleUsed === "left" ? V = t.initialWidth + t.initialClientX - p.clientX : V = t.initialWidth + p.clientX - t.initialClientX, r(
        Math.min(
          Math.max(V, 64),
          ((I = (S = e.editor.domElement) == null ? void 0 : S.firstElementChild) == null ? void 0 : I.clientWidth) || Number.MAX_VALUE
        )
      );
    }, H = () => {
      n(void 0), e.editor.updateBlock(e.block, {
        props: {
          previewWidth: o
        }
      });
    };
    return t && (window.addEventListener("mousemove", f), window.addEventListener("mouseup", H)), () => {
      window.removeEventListener("mousemove", f), window.removeEventListener("mouseup", H);
    };
  }, [e, t, o]);
  const s = g(() => {
    e.editor.isEditable && c(!0);
  }, [e.editor.isEditable]), a = g(() => {
    c(!1);
  }, []), u = g(
    (f) => {
      f.preventDefault(), n({
        handleUsed: "left",
        initialWidth: d.current.clientWidth,
        initialClientX: f.clientX
      });
    },
    []
  ), m = g(
    (f) => {
      f.preventDefault(), n({
        handleUsed: "right",
        initialWidth: d.current.clientWidth,
        initialClientX: f.clientX
      });
    },
    []
  ), h = _t(e.block.id);
  return /* @__PURE__ */ i(
    Oe,
    {
      ...e,
      onMouseEnter: s,
      onMouseLeave: a,
      style: e.block.props.url && !h && e.block.props.showPreview ? {
        width: o ? `${o}px` : "fit-content"
      } : void 0,
      children: /* @__PURE__ */ v("div", { className: "bn-visual-media-wrapper", ref: d, children: [
        e.children,
        (l || t) && /* @__PURE__ */ v(T, { children: [
          /* @__PURE__ */ i(
            "div",
            {
              className: "bn-resize-handle",
              style: { left: "4px" },
              onMouseDown: u
            }
          ),
          /* @__PURE__ */ i(
            "div",
            {
              className: "bn-resize-handle",
              style: { right: "4px" },
              onMouseDown: m
            }
          )
        ] })
      ] })
    }
  );
}, fi = (e) => {
  const t = Ne(e.block.props.url);
  return /* @__PURE__ */ i(
    "img",
    {
      className: "bn-visual-media",
      src: t.loadingState === "loading" ? e.block.props.url : t.downloadUrl,
      alt: e.block.props.caption || "BlockNote image",
      contentEditable: !1,
      draggable: !1
    }
  );
}, gi = (e) => {
  if (!e.block.props.url)
    return /* @__PURE__ */ i("p", { children: "Add image" });
  const t = e.block.props.showPreview ? /* @__PURE__ */ i(
    "img",
    {
      src: e.block.props.url,
      alt: e.block.props.name || e.block.props.caption || "BlockNote image",
      width: e.block.props.previewWidth
    }
  ) : /* @__PURE__ */ i("a", { href: e.block.props.url, children: e.block.props.name || e.block.props.url });
  return e.block.props.caption ? e.block.props.showPreview ? /* @__PURE__ */ i(Pe, { caption: e.block.props.caption, children: t }) : /* @__PURE__ */ i(fe, { caption: e.block.props.caption, children: t }) : t;
}, bi = (e) => /* @__PURE__ */ i(
  It,
  {
    ...e,
    buttonText: e.editor.dictionary.file_blocks.image.add_button_text,
    buttonIcon: /* @__PURE__ */ i(Ht, { size: 24 }),
    children: /* @__PURE__ */ i(fi, { ...e })
  }
), Ui = he(wn, {
  render: bi,
  parse: kn,
  toExternalHTML: gi
});
function Ci(e) {
  return k({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M14 3v4a1 1 0 0 0 1 1h4" }, child: [] }, { tag: "path", attr: { d: "M19 18v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1" }, child: [] }, { tag: "path", attr: { d: "M3 14h3m4.5 0h3m4.5 0h3" }, child: [] }, { tag: "path", attr: { d: "M5 10v-5a2 2 0 0 1 2 -2h7l5 5v2" }, child: [] }] })(e);
}
const pi = {
  page_break: Ci
};
function zi(e) {
  return vn(e).map((t) => {
    const n = pi[t.key];
    return {
      ...t,
      icon: /* @__PURE__ */ i(n, { size: 18 })
    };
  });
}
const ki = (e) => {
  const t = Ne(e.block.props.url);
  return /* @__PURE__ */ i(
    "video",
    {
      className: "bn-visual-media",
      src: t.loadingState === "loading" ? e.block.props.url : t.downloadUrl,
      controls: !0,
      contentEditable: !1,
      draggable: !1
    }
  );
}, wi = (e) => {
  if (!e.block.props.url)
    return /* @__PURE__ */ i("p", { children: "Add video" });
  const t = e.block.props.showPreview ? /* @__PURE__ */ i("video", { src: e.block.props.url }) : /* @__PURE__ */ i("a", { href: e.block.props.url, children: e.block.props.name || e.block.props.url });
  return e.block.props.caption ? e.block.props.showPreview ? /* @__PURE__ */ i(Pe, { caption: e.block.props.caption, children: t }) : /* @__PURE__ */ i(fe, { caption: e.block.props.caption, children: t }) : t;
}, vi = (e) => /* @__PURE__ */ i(
  It,
  {
    ...e,
    buttonText: e.editor.dictionary.file_blocks.video.add_button_text,
    buttonIcon: /* @__PURE__ */ i(Co, { size: 24 }),
    children: /* @__PURE__ */ i(ki, { ...e })
  }
), ji = he(Mn, {
  render: vi,
  parse: Hn,
  toExternalHTML: wi
}), Wi = (e) => {
  const [t, n] = w("none"), o = N(null), r = b(), l = O(
    r.formattingToolbar.onUpdate.bind(r.formattingToolbar)
  ), c = x(() => ({
    display: "flex",
    position: "fixed",
    bottom: 0,
    zIndex: 3e3,
    transform: t
  }), [t]);
  if (y(() => {
    const s = window.visualViewport;
    function a() {
      const u = document.body, m = s.offsetLeft, h = s.height - u.getBoundingClientRect().height + s.offsetTop;
      n(
        `translate(${m}px, ${h}px) scale(${1 / s.scale})`
      );
    }
    return window.visualViewport.addEventListener("scroll", a), window.visualViewport.addEventListener("resize", a), a(), () => {
      window.visualViewport.removeEventListener("scroll", a), window.visualViewport.removeEventListener("resize", a);
    };
  }, []), !l)
    return null;
  if (!l.show && o.current)
    return /* @__PURE__ */ i(
      "div",
      {
        ref: o,
        style: c,
        dangerouslySetInnerHTML: { __html: o.current.innerHTML }
      }
    );
  const d = e.formattingToolbar || St;
  return /* @__PURE__ */ i("div", { ref: o, style: c, children: /* @__PURE__ */ i(d, {}) });
}, Hi = P.memo(
  ({
    thread: e,
    selectedThreadId: t,
    editor: n,
    maxCommentsBeforeCollapse: o,
    referenceText: r
  }) => {
    const l = g(
      (d) => {
        var s;
        d.target.closest(".bn-action-toolbar") || (s = n.comments) == null || s.selectThread(e.id);
      },
      [n.comments, e.id]
    ), c = g(
      (d) => {
        var u;
        if (!d.relatedTarget || d.relatedTarget.closest(".bn-action-toolbar"))
          return;
        const s = d.target instanceof Node ? d.target : null, a = d.relatedTarget instanceof Node ? d.relatedTarget.closest(".bn-thread") : null;
        (!s || !a || !a.contains(s)) && ((u = n.comments) == null || u.selectThread(void 0));
      },
      [n.comments]
    );
    return /* @__PURE__ */ i(
      xt,
      {
        thread: e,
        selected: e.id === t,
        referenceText: r,
        maxCommentsBeforeCollapse: o,
        onFocus: l,
        onBlur: c,
        tabIndex: 0
      }
    );
  }
);
function Mi(e, t, n) {
  if (t === "recent-activity")
    return e.sort(
      (o, r) => r.comments[r.comments.length - 1].createdAt.getTime() - o.comments[o.comments.length - 1].createdAt.getTime()
    );
  if (t === "oldest")
    return e.sort(
      (o, r) => o.createdAt.getTime() - r.createdAt.getTime()
    );
  if (t === "position")
    return e.sort((o, r) => {
      var d, s;
      const l = ((d = n == null ? void 0 : n.get(o.id)) == null ? void 0 : d.from) || Number.MAX_VALUE, c = ((s = n == null ? void 0 : n.get(r.id)) == null ? void 0 : s.from) || Number.MAX_VALUE;
      return l - c;
    });
  throw new xn(t);
}
function tt(e, t) {
  return e.transact((n) => {
    if (!t)
      return "Original content deleted";
    if (n.doc.nodeSize < t.to)
      return "";
    const o = n.doc.textBetween(
      t.from,
      t.to
    );
    return o.length > 15 ? `${o.slice(0, 15)}…` : o;
  });
}
function $i(e) {
  const t = b();
  if (!t.comments)
    throw new Error("Comments plugin not found");
  const n = O(
    t.comments.onUpdate.bind(t.comments)
  ), o = n == null ? void 0 : n.selectedThreadId, r = yt(t), l = x(() => {
    const c = Array.from(r.values()), d = Mi(
      c,
      e.sort || "position",
      n == null ? void 0 : n.threadPositions
    ), s = [];
    for (const a of d)
      a.resolved ? (e.filter === "resolved" || e.filter === "all") && s.push({
        thread: a,
        referenceText: tt(
          t,
          n == null ? void 0 : n.threadPositions.get(a.id)
        )
      }) : (e.filter === "open" || e.filter === "all") && s.push({
        thread: a,
        referenceText: tt(
          t,
          n == null ? void 0 : n.threadPositions.get(a.id)
        )
      });
    return s;
  }, [r, n == null ? void 0 : n.threadPositions, e.filter, e.sort, t]);
  return /* @__PURE__ */ i("div", { className: "bn-threads-sidebar", children: l.map((c) => /* @__PURE__ */ i(
    Hi,
    {
      thread: c.thread,
      selectedThreadId: o,
      editor: t,
      referenceText: c.referenceText,
      maxCommentsBeforeCollapse: e.maxCommentsBeforeCollapse
    },
    c.thread.id
  )) });
}
function qi(e) {
  const t = D();
  if (e || (e = t == null ? void 0 : t.editor), !e)
    throw new Error(
      "'editor' is required, either from BlockNoteContext or as a function argument"
    );
  const n = e, [o, r] = w(() => n.getActiveStyles());
  return ue(() => {
    r(n.getActiveStyles());
  }, n), se(() => {
    r(n.getActiveStyles());
  }, n), o;
}
function xi() {
  const [, e] = w(0);
  return () => e((t) => t + 1);
}
const Ki = (e) => {
  const t = xi();
  y(() => {
    const n = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          t();
        });
      });
    };
    return e.on("transaction", n), () => {
      e.off("transaction", n);
    };
  }, [e]);
};
function yi(e) {
  return e.currentTarget instanceof HTMLElement && e.relatedTarget instanceof HTMLElement ? e.currentTarget.contains(e.relatedTarget) : !1;
}
function Xi({
  onBlur: e,
  onFocus: t
} = {}) {
  const n = N(null), [o, r] = w(!1), l = N(!1), c = (a) => {
    r(a), l.current = a;
  }, d = (a) => {
    l.current || (c(!0), t == null || t(a));
  }, s = (a) => {
    l.current && !yi(a) && (c(!1), e == null || e(a));
  };
  return y(() => {
    const a = n.current;
    if (a)
      return a.addEventListener("focusin", d), a.addEventListener("focusout", s), () => {
        a == null || a.removeEventListener("focusin", d), a == null || a.removeEventListener("focusout", s);
      };
  }, [d, s]), { ref: n, focused: o };
}
function Bi(e) {
  return (
    // Creates inline content section element
    /* @__PURE__ */ i(
      st,
      {
        as: "span",
        className: "bn-inline-content-section",
        "data-inline-content-type": e.inlineContentType,
        ...Object.fromEntries(
          Object.entries(e.inlineContentProps).filter(([t, n]) => {
            const o = e.propSchema[t];
            return n !== o.default;
          }).map(([t, n]) => [it(t), n])
        ),
        children: e.children
      }
    )
  );
}
function Yi(e, t) {
  const n = Te({
    name: e.type,
    inline: !0,
    group: "inline",
    selectable: e.content === "styled",
    atom: e.content === "none",
    content: e.content === "styled" ? "inline*" : "",
    addAttributes() {
      return rt(e.propSchema);
    },
    addKeyboardShortcuts() {
      return Sn(e);
    },
    parseHTML() {
      return Vn(e);
    },
    renderHTML({ node: o }) {
      const r = this.options.editor, l = Ae(
        o,
        r.schema.inlineContentSchema,
        r.schema.styleSchema
      ), c = t.render, d = ie(
        (s) => /* @__PURE__ */ i(
          c,
          {
            inlineContent: l,
            updateInlineContent: () => {
            },
            contentRef: s
          }
        ),
        r
      );
      return Bn(
        d,
        e.type,
        o.attrs,
        e.propSchema
      );
    },
    // TODO: needed?
    addNodeView() {
      const o = this.options.editor;
      return (r) => ct(
        (l) => {
          const c = at().nodeViewContentRef;
          if (!c)
            throw new Error("nodeViewContentRef is not set");
          const d = t.render;
          return /* @__PURE__ */ i(
            Bi,
            {
              inlineContentProps: l.node.attrs,
              inlineContentType: e.type,
              propSchema: e.propSchema,
              children: /* @__PURE__ */ i(
                d,
                {
                  contentRef: c,
                  inlineContent: Ae(
                    l.node,
                    o.schema.inlineContentSchema,
                    o.schema.styleSchema
                  ),
                  updateInlineContent: (s) => {
                    const a = yn(
                      [s],
                      o.pmSchema
                    );
                    o.transact(
                      (u) => u.replaceWith(
                        l.getPos(),
                        l.getPos() + l.node.nodeSize,
                        a
                      )
                    );
                  }
                }
              )
            }
          );
        },
        {
          className: "bn-ic-react-node-view-renderer",
          as: "span"
          // contentDOMElementTag: "span", (requires tt upgrade)
        }
      )(r);
    }
  });
  return Tn(e, {
    node: n
  });
}
var Y, He;
class Vi {
  constructor({
    mark: t,
    view: n,
    inline: o,
    options: r,
    editor: l
    // BlockNote specific
  }) {
    Ze(this, Y);
    L(this, "dom");
    L(this, "contentDOM");
    L(this, "mark");
    L(this, "view");
    L(this, "inline");
    L(this, "options");
    L(this, "editor");
    L(this, "shouldIgnoreMutation", (t) => !this.dom || !this.contentDOM ? !0 : t.type === "selection" ? !1 : this.contentDOM === t.target && t.type === "attributes" ? !0 : !this.contentDOM.contains(t.target));
    L(this, "ignoreMutation", (t) => {
      if (!this.dom || !this.contentDOM) return !0;
      let n;
      const o = this.options.ignoreMutation;
      return o && (n = o(t)), typeof n != "boolean" && (n = this.shouldIgnoreMutation(t)), n;
    });
    this.mark = t, this.view = n, this.inline = o, this.options = r, this.editor = l, this.dom = this.createDOM(r.as), this.contentDOM = r.contentAs ? this.createContentDOM(r.contentAs) : void 0, this.dom.setAttribute("data-mark-view-root", "true"), this.contentDOM && (this.contentDOM.setAttribute("data-mark-view-content", "true"), this.contentDOM.style.whiteSpace = "inherit");
  }
  createDOM(t) {
    return ge(this, Y, He).call(this, t);
  }
  createContentDOM(t) {
    return ge(this, Y, He).call(this, t);
  }
  get component() {
    return this.options.component;
  }
  destroy() {
    var t, n, o;
    (n = (t = this.options).destroy) == null || n.call(t), this.dom.remove(), (o = this.contentDOM) == null || o.remove();
  }
}
Y = new WeakSet(), He = function(t) {
  const { inline: n, mark: o } = this;
  return t == null ? document.createElement(n ? "span" : "div") : t instanceof HTMLElement ? t : t instanceof Function ? t(o) : document.createElement(t);
};
class Si extends Vi {
  constructor() {
    super(...arguments);
    // implements ReactRenderer<MarkViewContext>
    // key: string = nanoid();
    L(this, "id", Math.floor(Math.random() * 4294967295).toString());
    L(this, "context", {
      contentRef: (n) => {
        n && this.contentDOM && n.firstChild !== this.contentDOM && n.appendChild(this.contentDOM);
      },
      view: this.view,
      mark: this.mark
    });
    L(this, "updateContext", () => {
      Object.assign(this.context, {
        mark: this.mark
      });
    });
    // render = () => {
    //   const UserComponent = this.component;
    //   return createPortal(
    //     <markViewContext.Provider value={this.context}>
    //       <UserComponent />
    //     </markViewContext.Provider>,
    //     this.dom,
    //     this.key
    //   );
    // };
    L(this, "render", () => {
      this.editor._tiptapEditor.contentComponent.setRenderer(
        this.id,
        this.renderer()
      );
    });
    L(this, "destroy", () => {
      super.destroy(), this.editor._tiptapEditor.contentComponent.removeRenderer(this.id);
    });
    L(this, "renderer", () => {
      const n = this.component, o = {};
      return this.mark.attrs.stringValue && (o.value = this.mark.attrs.stringValue), {
        reactElement: (
          // <markViewContext.Provider value={this.context}>
          /* @__PURE__ */ i(n, { contentRef: this.context.contentRef, ...o })
        ),
        element: this.dom
      };
    });
  }
}
function Ji(e, t) {
  const n = In.create({
    name: e.type,
    addAttributes() {
      return Rn(e.propSchema);
    },
    parseHTML() {
      return En(e);
    },
    renderHTML({ mark: o }) {
      const r = {};
      e.propSchema === "string" && (r.value = o.attrs.stringValue);
      const l = t.render, c = ie(
        (d) => /* @__PURE__ */ i(l, { ...r, contentRef: d }),
        this.options.editor
      );
      return Ln(
        c,
        e.type,
        o.attrs.stringValue,
        e.propSchema
      );
    }
  });
  return n.config.addMarkView = (o) => (r, l) => {
    const c = new Si({
      editor: o,
      inline: !0,
      mark: r,
      options: {
        component: t.render,
        contentAs: "span"
      },
      view: l
    });
    return c.render(), c;
  }, _n(e, {
    mark: n
  });
}
function Qi(e, t) {
  const n = e.getBoundingClientRect(), o = t.getBoundingClientRect(), r = n.top < o.top, l = n.bottom > o.bottom;
  return r && l ? "both" : r ? "top" : l ? "bottom" : "none";
}
export {
  dr as AddBlockButton,
  Je as AddButton,
  Xo as AddCommentButton,
  ci as AddFileButton,
  Yo as AddTiptapCommentButton,
  ui as AudioBlock,
  si as AudioPreview,
  di as AudioToExternalHTML,
  ne as BasicTextStyleButton,
  mr as BlockColorsItem,
  pe as BlockContentWrapper,
  dt as BlockNoteContext,
  Kr as BlockNoteDefaultUI,
  oi as BlockNoteViewEditor,
  Fi as BlockNoteViewRaw,
  Ko as BlockTypeSelect,
  zr as ColorPickerButton,
  Zo as ColorStyleButton,
  Lo as Comment,
  Eo as Comments,
  On as ComponentsContext,
  Ao as CreateLinkButton,
  _r as DeleteButton,
  rr as DeleteLinkButton,
  Cr as DragHandleButton,
  br as DragHandleMenu,
  ir as EditLinkButton,
  Vt as EditLinkMenuItems,
  _o as EmbedTab,
  Wi as ExperimentalMobileFormattingToolbarController,
  Rr as ExtendButton,
  Pe as FigureWithCaption,
  hi as FileBlock,
  Oe as FileBlockWrapper,
  Go as FileCaptionButton,
  Uo as FileDeleteButton,
  Jo as FileDownloadButton,
  ai as FileNameWithIcon,
  Bt as FilePanel,
  No as FilePanelController,
  Qo as FilePreviewButton,
  zo as FileRenameButton,
  jo as FileReplaceButton,
  mi as FileToExternalHTML,
  Fn as FloatingComposer,
  An as FloatingComposerController,
  Ro as FloatingThreadController,
  St as FormattingToolbar,
  or as FormattingToolbarController,
  xr as GridSuggestionMenuController,
  Mr as GridSuggestionMenuWrapper,
  bi as ImageBlock,
  fi as ImagePreview,
  gi as ImageToExternalHTML,
  Bi as InlineContentWrapper,
  cr as LinkToolbar,
  ar as LinkToolbarController,
  fe as LinkWithCaption,
  Wo as NestBlockButton,
  lr as OpenLinkButton,
  Ai as ReactAudioBlock,
  Gi as ReactFileBlock,
  Ui as ReactImageBlock,
  ji as ReactVideoBlock,
  hr as RemoveBlockItem,
  It as ResizableFileBlockWrapper,
  pr as SideMenu,
  kr as SideMenuController,
  jr as SplitButton,
  Lr as SuggestionMenuController,
  Vr as SuggestionMenuWrapper,
  $r as TableCellButton,
  Wr as TableCellMenu,
  er as TableCellMergeButton,
  gr as TableColumnHeaderItem,
  Dr as TableHandle,
  Or as TableHandleMenu,
  qr as TableHandlesController,
  fr as TableRowHeaderItem,
  be as TextAlignButton,
  xt as Thread,
  $i as ThreadsSidebar,
  $o as UnnestBlockButton,
  Io as UploadTab,
  vi as VideoBlock,
  ki as VideoPreview,
  wi as VideoToExternalHTML,
  qo as blockTypeSelectItems,
  he as createReactBlockSpec,
  Yi as createReactInlineContentSpec,
  Ji as createReactStyleSpec,
  Qi as elementOverflow,
  wr as getDefaultReactEmojiPickerItems,
  Tr as getDefaultReactSlashMenuItems,
  nr as getFormattingToolbarItems,
  zi as getPageBreakReactSlashMenuItems,
  tt as getReferenceText,
  Po as mergeRefs,
  qi as useActiveStyles,
  Oi as useBlockNote,
  D as useBlockNoteContext,
  b as useBlockNoteEditor,
  Lt as useCloseSuggestionMenuNoItems,
  C as useComponentsContext,
  de as useCreateBlockNote,
  M as useDictionary,
  ue as useEditorChange,
  U as useEditorContentOrSelectionChange,
  Ki as useEditorForceUpdate,
  se as useEditorSelectionChange,
  Zr as useExtendButtonsPositioning,
  Xi as useFocusWithin,
  Hr as useGridSuggestionMenuKeyboardNavigation,
  Et as useLoadSuggestionMenuItems,
  Xr as usePrefersColorScheme,
  Ne as useResolveUrl,
  _ as useSelectedBlocks,
  Br as useSuggestionMenuKeyboardNavigation,
  Ur as useTableHandlesPositioning,
  yt as useThreads,
  So as useUser,
  Ie as useUsers
};
//# sourceMappingURL=blocknote-react.js.map
